if ($('#app-campaigns-form-planner').length || $('#app-campaigns-form-planner-monthly').length) {
        var budget_details = [];

        $('#campaign_number').mask('000000', {
            placeholder:"000000",
            insertMode:true,
            clearIncomplete:false,
            dataMask:true,
        });

        $('#campaign_estimate').mask('000000', {
            placeholder:"000000",
            insertMode:true,
            clearIncomplete:false,
            dataMask:true,
        });

        var url = $(location).attr("href");
        var once_time_budget = false;
        var campaigns_to_copy_rows_markets;
        var save_det = $("#campaign_budget").val();
        var details_no_empty = '';

        /*if(url.indexOf("advertisers") !== -1 && url.indexOf("campaigns") !== -1) {
    window.onbeforeunload = function () {
        if ($('#app-campaigns-update-form').serialize() !== $('#app-campaigns-update-form').data('serialize')) {
            return "Do you want to leave the page without save changes?";
        }
    };
}*/

        if (typeof budget_details_edit !== 'undefined') {
            for (var i in budget_details_edit) {
                budget_details[budget_details_edit[i]['market_id'] + "_" + budget_details_edit[i]['media_type'] + "_id"] = budget_details_edit[i]['budget'];
            }
        }

        /*$(document).on('keydown', function(e){
    console.log("DOWN");
    if (e.keyCode == 9) {
        e.preventDefault();
        var $focused = $(':focus');
        var ind = $focused.index('input:text');
        var next = ind + 1;
        var $next = $('input:text').eq(next);
        console.log($next);
        $next.focus();
    }
});*/

        $("#reset_details").on('click', function () {
            $(".tabs").each(function () {
                $(this).val("$0.00");
            });
            $("#det_tot_budget").html("$0.00");
        });

        $(document).on('keyup', function (e) {
            if (typeof e.originalEvent.path[0]['formAction'] !== 'undefined' && e.originalEvent.path[0]['formAction'].indexOf("/ws/") === -1) {
                if ((e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 96 && e.keyCode <= 105) || e.keyCode == 8 || e.keyCode == 46) {
                    var $focused = $(':focus');
                    console.log("SUM");
                    if ($focused.hasClass("tabs")) {
                        console.log("SUM1");
                        var $tot_camp = $("#camp_tot_budget");
                        var $det_camp = $("#det_tot_budget");
                        var total = 0;
                        $(".tabs").each(function () {
                            var str = $(this).val().replace('$', '');
                            var cc = 0;
                            var position = str.indexOf(",");
                            while ( position != -1 ) {
                                cc++;
                                position = str.indexOf(",",position+1);
                            }
                            console.log('cc',cc);
                            for(i=0; i < cc; i++)
                                str = str.replace(',', '');

                            if (!isNaN(parseFloat(str)))
                                total += parseFloat(str);
                            else
                                console.log(str);
                        });

                        var camp_b = (isNaN(parseFloat($("#campaign_budget").val().replace(',', '')))) ? 0 : parseFloat($("#campaign_budget").val().replace(',', ''));
                        $det_camp.html("$" + total.toFixed(2));
                        if (camp_b < total) {
                            if (once_time_budget === false)
                                global_notification('info', 'The campaign budget changed because your detailed budget is bigger!');
                            once_time_budget = true;
                            //     $("#campaign_budget").val(total.toFixed(2));
                            $tot_camp.html("$" + total.toFixed(2));
                            save_det = total.toFixed(2);
                            details_no_empty = total.toFixed(2);
                        } else {
                            if (once_time_budget == true) {
                                $tot_camp.html("$" + total.toFixed(2));
                                $tot_camp.val(total.toFixed(2));
                                save_det = total.toFixed(2);
                                details_no_empty = total.toFixed(2);
                            }

                        }
                        budget_details[$focused.attr('id')] = $focused.val();
                    }
                }
            }
        });
        $('#campaign_budget').on('change', function (e) {
            if ((typeof budget_details_to_message !== 'undefined' && budget_details_to_message.length > 0) || details_no_empty != '') {
                swal({
                        title: "Warning",
                        text: "The Campaign has a Detailed Budget. Are yo sure to edit?",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonClass: "btn-danger",
                        confirmButtonText: "Ok",
                        cancelButtonText: "Cancel",
                        closeOnConfirm: true,
                        closeOnCancel: true
                    },
                    function (isConfirm) {
                        if (!isConfirm) {
                            $("#campaign_budget").val(save_det);
                            $("#campaign_budget").html('$' + save_det);
                        }
                    });
            }
        });

        $('.close_budget_details').on('click', function () {
            if ($("#campaign_budget").val() != 0) {
                var cbug = $("#campaign_budget").val();
                if (details_no_empty != '') {
                    if (cbug != $("#camp_tot_budget").val()) {
                        swal({
                                title: "Warning",
                                text: "The Detailed Budget does not match with Campaign Budget.",
                                type: "warning",
                                showCancelButton: true,
                                confirmButtonClass: "btn-danger",
                                confirmButtonText: "Keep Detail",
                                cancelButtonText: "Keep Original",
                                closeOnConfirm: true,
                                closeOnCancel: true
                            },
                            function (isConfirm) {
                                if (isConfirm) {
                                    $("#campaign_budget").val(save_det);
                                    $("#campaign_budget").html('$' + save_det);
                                }
                                $('#addBudgetDetailsModal').modal('hide');
                            });
                    }
                    $('#addBudgetDetailsModal').modal('hide');
                }
                $('#addBudgetDetailsModal').modal('hide');
            } else {
                $("#campaign_budget").val(save_det);
                $("#campaign_budget").html('$' + save_det);
                $('#addBudgetDetailsModal').modal('hide');
            }

        });

        $('#add_budget_details').on('click', function (e) {
            if ($('#campaign_markets').val().length > 0 || $('#campaign_markets_msa').val().length > 0 || $('#campaign_markets_custom').val().length > 0) {
                var imp = $("#budget_content");
                var html = '<table style="width: 100%; border: 0px">';
                html += '<tr><td style="width: 25%"></td>';
                $("#campaign_media_types option:selected").each(function () {
                    html += '<td>' + $(this).text() + '</td>';
                });
                html += '</tr>';
                var tcount = 1;
                var mlength = $("#campaign_media_types option:selected").length;
                if (mlength === 0) {
                    html += '<tr><td style="width: 100%;text-align: center"><b>PLEASE SELECT AT LEAST ONE MEDIA TYPE!</b></td></tr>';
                } else {
                    html += '<tr><td colspan="' + (mlength + 1) + '" style="border-bottom: 1px solid black"><b>DMA MARKETS</b></td></tr>';
                    $("#campaign_markets option:selected").each(function () {
                        html += '<tr><td>' + $(this).text() + '</td>';
                        var market = $(this).val();
                        $("#campaign_media_types option:selected").each(function () {
                            html += '<td><input placeholder="0.00" class="form-control tabs" style="width: 90%" type="text" value="' + ((typeof budget_details[market + '_' + $(this).val() + '_id'] !== 'undefined') ? budget_details[market + '_' + $(this).val() + '_id'] : '0.00') + '" name="dma_budget_details[' + market + '][' + $(this).val() + ']" id="' + market + '_' + $(this).val() + '_id"></td>';
                        });
                        html += '</tr>';
                    });
                    html += '<tr><td colspan="' + (mlength + 1) + '" style="border-bottom: 1px solid black"><b>MSA MARKETS</b></td></tr>';
                    $("#campaign_markets_msa option:selected").each(function () {
                        html += '<tr><td>' + $(this).text() + '</td>';
                        var market = $(this).val();
                        $("#campaign_media_types option:selected").each(function () {
                            html += '<td><input placeholder="0.00" class="form-control tabs" style="width: 90%" type="text" value="' + ((typeof budget_details[market + '_' + $(this).val() + '_id'] !== 'undefined') ? budget_details[market + '_' + $(this).val() + '_id'] : '0.00') + '" name="msa_budget_details[' + market + '][' + $(this).val() + ']" id="' + market + '_' + $(this).val() + '_id"></td>';
                        });
                        html += '</tr>';
                    });
                    html += '<tr><td colspan="' + (mlength + 1) + '" style="border-bottom: 1px solid black"><b>NATIONAL AND CUSTOM MARKETS</b></td></tr>';
                    $("#campaign_markets_custom option:selected").each(function () {
                        html += '<tr><td>' + $(this).text() + '</td>';
                        var market = $(this).val();
                        $("#campaign_media_types option:selected").each(function () {
                            html += '<td><input placeholder="0.00" class="form-control tabs" style="width: 90%" type="text" value="' + ((typeof budget_details[market + '_' + $(this).val() + '_id'] !== 'undefined') ? budget_details[market + '_' + $(this).val() + '_id'] : '0.00') + '" name="custom_budget_details[' + market + '][' + $(this).val() + ']" id="' + market + '_' + $(this).val() + '_id"></td>';
                        });
                        html += '</tr>';
                    });
                }
                html += '</table>';
                imp.html(html);

                if (mlength > 0) {
                    $("#campaign_markets option:selected").each(function () {
                        var market = $(this).val();
                        $("#campaign_media_types option:selected").each(function () {
                            new AutoNumeric('#' + market + '_' + $(this).val() + '_id',
                                {
                                    currencySymbol: '$',
                                    minimumValue: 0,
                                    selectOnFocus: true,
                                    caretPositionOnFocus: null,
                                    digitGroupSeparator: ',',
                                    digitalGroupSpacing: '3',
                                    decimalCharacter: '.',
                                    allowDecimalPadding: true,
                                    showOnlyNumbersOnFocus: true,
                                    showWarnings: false,
                                });
                        });
                    });
                    $("#campaign_markets_msa option:selected").each(function () {
                        var market = $(this).val();
                        $("#campaign_media_types option:selected").each(function () {
                            new AutoNumeric('#' + market + '_' + $(this).val() + '_id',
                                {
                                    currencySymbol: '$',
                                    minimumValue: 0,
                                    selectOnFocus: true,
                                    caretPositionOnFocus: null,
                                    digitGroupSeparator: ',',
                                    digitalGroupSpacing: '3',
                                    decimalCharacter: '.',
                                    allowDecimalPadding: true,
                                    showOnlyNumbersOnFocus: true,
                                    showWarnings: false,
                                });
                        });
                    });
                    $("#campaign_markets_custom option:selected").each(function () {
                        var market = $(this).val();
                        $("#campaign_media_types option:selected").each(function () {
                            new AutoNumeric('#' + market + '_' + $(this).val() + '_id',
                                {
                                    currencySymbol: '$',
                                    minimumValue: 0,
                                    selectOnFocus: true,
                                    caretPositionOnFocus: null,
                                    digitGroupSeparator: ',',
                                    digitalGroupSpacing: '3',
                                    decimalCharacter: '.',
                                    allowDecimalPadding: true,
                                    showOnlyNumbersOnFocus: true,
                                    showWarnings: false,
                                });
                        });
                    });
                }

                $("#camp_tot_budget").html("$" + $("#campaign_budget").val());
                details_no_empty = $("#det_tot_budget").val();

                var total = 0;
                $(".tabs").each(function () {
                    console.log('$(this).val()', $(this).val());
                    var str = $(this).val().replace('$', '');
                    var cc = 0;
                    var position = str.indexOf(",");
                    while ( position != -1 ) {
                        cc++;
                        position = str.indexOf(",",position+1);
                    }
                    for(i=0; i < cc; i++)
                        str = str.replace(',', '');

                    if (!isNaN(parseFloat(str)))
                        total += parseFloat(str);

                });
                $("#det_tot_budget").html("$" + total.toFixed(2));

                $('#addBudgetDetailsModal').modal('show');
            } else {
                swal({
                        title: "Warning",
                        text: "Please add at least one Market first.",
                        type: "warning",
                        showCancelButton: false,
                        confirmButtonClass: "btn-danger",
                        confirmButtonText: "OK",
                        // cancelButtonText: "No",
                        closeOnConfirm: true,
                        closeOnCancel: true
                    },
                    function (isConfirm) {
                        if (isConfirm) {
                        }

                    });
            }
        });

        if (typeof comscore_tv !== 'undefined' && comscore_tv === true) {
            var demo_all = [];
            $(document).ready(function () {
                //Adds the Comscore Demographics data to the Comscore Demo tab select input
                if ($("#comscore_tv_demo_ids").length) {
                    show_loader()
                    //console.log("COMSCORE SECONDARY DEMOS: ", comscore_tv_existing_sec_demo)
                    console.log("COMSCORE SECONDARY DEMOS: ");
                    $.ajax({
                        type: "GET",
                        url: '/ratings/comscore/metadata/demographics ',
                        dataType: 'json',
                        success: function (data) {
                            show_loader()
                            var html = '';
                            html += '';
                            demo_all = data['result_rows'];
                            demo_all.sort(function (a, b) {
                                var au = a[2];
                                var bu = b[2];
                                return au.localeCompare(bu);
                            });
                            console.log("THIS ARE THE COMSCORE DEMOS: ", data)
                            console.log("THIS ARE THE SORT DEMOS: ", demo_all)
                            // if($('input:radio[name=comscore_tv_demo_type]:checked').length)
                            //     var demo= $('input:radio[name=comscore_tv_demo_type]:checked').val();
                            // else
                            //     var demo = 'p';
                            //
                            // $("input[name=comscore_tv_demo_name]").val("");
                            // $.each(data['result_rows'], function (index, value) {
                            //     /* if(value[11].indexOf('Age Range') !== -1)
                            //       html += '<option value="'+ value[0] +'">'+ value[2] +'</option>';*/
                            //
                            //     var selected = (typeof  comscore_tv_existing_demo !== "undefined" && comscore_tv_existing_demo !== null && comscore_tv_existing_demo["demo_ids"] == value[0])?"selected":"";
                            //
                            //     if(value[12].indexOf('Age Range') !== -1){
                            //         if(demo== 'p') {
                            //             if (value[2].indexOf('A') !== -1) {
                            //                 var ts= value[2].replace('A', "P ");
                            //                 html += '<option value="' + value[0] + '" ' + selected + '>' + ts + '</option>';
                            //                 $("input[name=comscore_tv_demo_name]").val(ts);
                            //             }
                            //         }
                            //         if(demo== 'm') {
                            //             if (value[2].indexOf('M') !== -1) {
                            //                 var ts= value[2].replace('M', "M ");
                            //                 html += '<option value="' + value[0] + '" ' + selected + '>' + ts + '</option>';
                            //                 $("input[name=comscore_tv_demo_name]").val(ts);
                            //             }
                            //         }
                            //         if(demo== 'f') {
                            //             if (value[2].indexOf('W') !== -1) {
                            //                 var ts= value[2].replace('W', "F ");
                            //                 html += '<option value="' + value[0] + '" ' + selected + '>' + ts + '</option>';
                            //                 $("input[name=comscore_tv_demo_name]").val(ts);
                            //             }
                            //         }
                            //     }
                            //     if(value[12].indexOf('Household Composition') !== -1){
                            //         if(demo == 'hh') {
                            //             html += '<option value="' + value[0] + '" ' + selected + '>' + value[2] + '</option>';
                            //             $("input[name=comscore_tv_demo_name]").val(value[2]);
                            //         }
                            //     }
                            //
                            // });
                            // if(typeof  comscore_tv_existing_demo !== "undefined" && comscore_tv_existing_demo !== null)
                            //     $("input[name=comscore_tv_demo_name]").val(comscore_tv_existing_demo["demo_name"]);
                            // $("#comscore_tv_demo_ids").html(html);
                            if (typeof comscore_tv_existing_sec_demo !== 'undefined' && comscore_tv_existing_sec_demo.length > 0) {
                                $("#comscore_tv_demo_type_" + comscore_tv_existing_sec_demo[0].demo_type).prop("checked", true)
                                comscore_options_html("#comscore_tv_demo_ids")
                            }
                            if (typeof comscore_tv_existing_sec_demo !== 'undefined' && comscore_tv_existing_sec_demo.length > 1) {
                                for (var i = 1; i < comscore_tv_existing_sec_demo.length; i++) {
                                    $("#comscore_tv_demo_type_" + comscore_tv_existing_sec_demo[i].demo_type + "_" + i).prop("checked", true)
                                    comscore_options_html("#comscore_tv_demo_ids_" + i)
                                }
                            }

                            $('input[type=radio][name=comscore_tv_demo_type]').change(function () {
                                comscore_options_html("#comscore_tv_demo_ids")
                                // var demo= $('input:radio[name=comscore_tv_demo_type]:checked').val();
                                // var html='';
                                // $('#comscore_tv_demo_ids').html(html);
                                // $("input[name=comscore_tv_demo_name]").val("");
                                // $.each(demo_all, function (index, value) {
                                //     if(value[12].indexOf('Age Range') !== -1){
                                //         if(demo== 'p') {
                                //             if (value[2].indexOf('A') !== -1) {
                                //                 var ts= value[2].replace('A', "P ");
                                //                 html += '<option value="' + value[0] + '">' + ts + '</option>';
                                //                 $("input[name=comscore_tv_demo_name]").val(ts);
                                //             }
                                //         }
                                //         if(demo== 'm') {
                                //             if (value[2].indexOf('M') !== -1) {
                                //                 var ts= value[2].replace('M', "M ");
                                //                 html += '<option value="' + value[0] + '">' + ts + '</option>';
                                //                 $("input[name=comscore_tv_demo_name]").val(ts);
                                //             }
                                //         }
                                //         if(demo== 'f') {
                                //             if (value[2].indexOf('W') !== -1) {
                                //                 var ts= value[2].replace('W', "F ");
                                //                 html += '<option value="' + value[0] + '">' + ts + '</option>';
                                //                 $("input[name=comscore_tv_demo_name]").val(ts);
                                //             }
                                //         }
                                //     }
                                //     if(value[12].indexOf('Household Composition') !== -1){
                                //         if(demo == 'hh') {
                                //             html += '<option value="' + value[0] + '">' + value[2] + '</option>';
                                //             $("input[name=comscore_tv_demo_name]").val(value[2]);
                                //         }
                                //     }
                                // });
                                // $('#comscore_tv_demo_ids').html(html);
                            });
                            if (typeof comscore_tv_existing_sec_demo !== 'undefined' && comscore_tv_existing_sec_demo.length > 1) {
                                for (var i = 1; i < comscore_tv_existing_sec_demo.length; i++) {
                                    $('input[type=radio][name=comscore_tv_demo_type_' + (i.toString()) + ']').change(function () {
                                        comscore_options_html("#comscore_tv_demo_ids_" + ($(this).attr("name").split("comscore_tv_demo_type_")[1].toString()))
                                    });
                                }
                            }

                            if (typeof comscore_tv_existing_sec_demo === 'undefined') {
                                comscore_options_html("#comscore_tv_demo_ids")
                            }

                            hide_loader()
                        },
                        error: function (err) {
                            console.log(err);
                            hide_loader();
                            debug(err.responseText);

                        }
                    });
                }
                //if (typeof comscore_tv_existing !== 'undefined') {
                var hide_loader_cont = 0;
                if (/*comscore_tv_existing !== false*/typeof actual_markets !== "undefined" && actual_markets.length > 0) {
                    $.each(/*comscore_tv_existing*/actual_markets, function (index, market) {
                        var coms_index = comscore_markets.findIndex(elem => market['code'] === elem['code'])
                        if (market["type"] === "dma" && coms_index !== -1) {
                            var html = '<div class="form-inline row market-ratings-container" data-market="' + market['code'] + '" data-media="tv"><div class="form-group col-md-3 m-b-10"><div class="col-md-12"><input class="form-control full-width nielsen_tv_market" id="comscore_tv_market" name="comscore_tv_market_name[]" value="' + market['name'] + '" readonly><input type="hidden" name="comscore_tv_market[]" value="' + market['code'] + '"/></div></div><div class="form-group col-md-3 m-b-10"><div class="col-md-12"><select class="form-control full-width" id="comscore_tv_playback_type" name="comscore_tv_playback_type[]">' +
                                '<option value="">Choose One...</option>' +
                                '<option value="live">Live Only</option>' +

                                // '<option value="dvr_within_same_day">Live Same Day</option>' +
                                // '<option value="dvr_within_24_hours">Live within 24 hours</option>' +
                                // '<option value="dvr_within_48_hours">Live within 48 hours</option>' +
                                // '<option value="dvr_within_72_hours">Live within 72 hours</option>' +
                                // '<option vlalue="dvr_within_168_hours">Live within 168 hours</option>' +
                                // '<option value="dvr_within_360_hours">Live within 360 hours</option>' +
                                //
                                // '<option value="live_plus_dvr_within_same_day">Live and DVR Same Day</option>' +
                                // '<option value="live_plus_dvr_within_24_hours">Live and DVR within 24 hours</option>' +
                                // '<option value="live_plus_dvr_within_48_hours">Live and DVR within 48 hours</option>' +
                                // '<option value="live_plus_dvr_within_72_hours">Live and DVR within 72 hours</option>' +
                                // '<option value="live_plus_dvr_within_168_hours">Live and DVR within 168 hours</option>' +
                                // '<option value="live_plus_dvr_within_360_hours">Live and DVR within 360 hours</option>' +
                                //
                                // '<option value="ad_live">Live Ad Only</option>' +
                                //
                                // '<option value="ad_live_plus_dvr_within_same_day">Live and DVR Ad Same Day</option>' +
                                // '<option value="ad_live_plus_dvr_within_24_hours">Live and DVR Ad within 24 hours</option>' +
                                // '<option value="ad_live_plus_dvr_within_48_hours">Live and DVR Ad within 48 hours</option>' +
                                // '<option value="ad_live_plus_dvr_within_72_hours">Live and DVR Ad within 72 hours</option>' +
                                // '<option value="ad_live_plus_dvr_within_168_hours">Live and DVR Ad within 168 hours</option>' +
                                // '<option value="ad_live_plus_dvr_within_360_hours">Live and DVR Ad within 360 hours</option>' +
                                //
                                // '<option value="ad_live_plus_dvr_vod_within_same_day">Live, DVR and VOD Same Day</option>' +
                                // '<option value="ad_live_plus_dvr_vod_within_24_hours">Live, DVR and VOD within 24 hours</option>' +
                                // '<option value="ad_live_plus_dvr_vod_within_48_hours">Live, DVR and VOD within 48 hours</option>' +
                                // '<option value="ad_live_plus_dvr_vod_within_72_hours">Live, DVR and VOD within 72 hours</option>' +
                                // '<option value="ad_live_plus_dvr_vod_within_168_hours">Live, DVR and VOD within 168 hours</option>' +
                                // '<option value="ad_live_plus_dvr_vod_within_360_hours">Live, DVR and VOD within 360 hours</option>' +
                                '</select></div></div>'; //+
                            /*'<div class="form-group col-md-2 m-b-10"><div class="col-md-12"><select type="text" name="avails_view_year[]" id="avails_view_year" class="form-control full-width" ><option value="">Choose a Year...</option>';*/
                            var htmltoadd = ""
                            // var nowTime = (moment(comscore_markets[coms_index].end) < moment()) ? moment(comscore_markets[coms_index].end) : moment()
                            // var gtrTime = moment(comscore_markets[coms_index].start)//moment().subtract(1, 'months').subtract(2, 'years')
                            console.log('Its here');
                            for (let marketDate in comscore_markets[coms_index].agency_comscore_markets) {
                                let month = comscore_markets[coms_index].agency_comscore_markets[marketDate].month
                                if(comscore_markets[coms_index].agency_comscore_markets[marketDate].status === 'Completed') {
                                    htmltoadd += '<option value="' + moment(month).format('MM/YYYY') + '">' + moment(month).format('MM/YYYY') + '</option>';
                                }
                            }

                            // while(nowTime >= gtrTime){
                            //     htmltoadd += '<option value="' + nowTime.format("MM/YYYY") + '">' + nowTime.format("MM/YYYY") + '</option>';
                            //     nowTime.subtract(1, 'months')
                            // }
                            html += /*'</select></div></div>' +*/
                                '<div class="form-group col-md-2 m-b-10"><div class="col-md-12"><select class="form-control full-width" id="comscore_interval" name="comscore_interval[]"><option value="">Select a Date</option>' + htmltoadd + '</select></div></div><div class="form-group col-md-2 m-b-10"><div class="col-md-12"><select name="avails_view_quarter[]" id="avails_view_quarter" class="form-control full-width"><option value="">Select a Date</option>' + htmltoadd + '</select></div></div></div>';
                            var container = $('#comscore_dat').find('.comscore_books_container');
                            $(html).find('#comscore_tv_market').val(market['name']);

                            container.append(html);
                            //selectComscoreYearBooksChange(container.find('div[data-market="' + market['code'] + '"] #comscore_interval'))
                            var index_exists = comscore_tv_existing.findIndex(elem => market['code'] === elem['dma'])
                            if (index_exists !== -1) {
                                container.find('div[data-market="' + market['code'] + '"] #comscore_tv_playback_type').val(comscore_tv_existing[index_exists]['playback_type']).trigger('change');
                                container.find('div[data-market="' + market['code'] + '"] #avails_view_year').val(comscore_tv_existing[index_exists]['year']).trigger('change');
                                container.find('div[data-market="' + market['code'] + '"] #comscore_interval').val(comscore_tv_existing[index_exists]['share_book']).trigger('change').select2();
                                container.find('div[data-market="' + market['code'] + '"] #avails_view_quarter').val(comscore_tv_existing[index_exists]['hut_book']).trigger('change').select2();
                            } else {
                                container.find('div[data-market="' + market['code'] + '"] #comscore_interval').select2();
                                container.find('div[data-market="' + market['code'] + '"] #avails_view_quarter').select2();
                            }
                        }
                    });
                    $('select[name="comscore_tv_playback_type[]"]').select2()
                }
                //}
            })
            var comscore_options_html = function (comscore_select_id) {
                if (demo_all.length > 0) {
                    if ($(comscore_select_id).parent().parent().find('input:radio:checked').length)
                        var demo = $(comscore_select_id).parent().parent().find('input:radio:checked').val();
                    else
                        var demo = 'p';
                    var html = '';
                    $(comscore_select_id).html(html);
                    $(comscore_select_id).parent().children("input.comscore_tv_demo_name_all").val("");
                    var input_demo_val = (demo !== "hh") ? demo.toUpperCase() + " 18-24" : "---"
                    var position = (comscore_select_id === "#comscore_tv_demo_ids") ? 0 : comscore_select_id.split("#comscore_tv_demo_ids_")[1]
                    $.each(demo_all, function (index, value) {
                        var selected = (typeof comscore_tv_existing_sec_demo !== "undefined" && comscore_tv_existing_sec_demo !== null && comscore_tv_existing_sec_demo.length > 0 && typeof comscore_tv_existing_sec_demo[position] !== "undefined" && typeof comscore_tv_existing_sec_demo[position].demo_ids !== "undefined" && comscore_tv_existing_sec_demo[position].demo_ids == value[0] && typeof comscore_tv_existing_sec_demo[position].demo_type !== "undefined" && comscore_tv_existing_sec_demo[position].demo_type == demo/*typeof comscore_tv_existing_sec_demo.find(elem => elem.demo_ids == value[0]) !== 'undefined'*/) ? "selected" : "";
                        if (value[12].indexOf('Age Range') !== -1) {
                            if (demo == 'p') {
                                if (value[2].indexOf('A') !== -1) {
                                    var ts = value[2].replace('A', "P ");
                                    html += '<option title="' + ts + '" value="' + value[0] + '" ' + selected + '>' + ts + '</option>';
                                    //(selected === "selected") ? $(comscore_select_id).parent().find("input.comscore_tv_demo_name_all").val(ts) : $(comscore_select_id).parent().find("input.comscore_tv_demo_name_all").val("P 18-24");
                                    if (selected === "selected")
                                        input_demo_val = ts
                                }
                            }
                            if (demo == 'm') {
                                if (value[2].indexOf('M') !== -1) {
                                    var ts = value[2].replace('M', "M ");
                                    html += '<option title="' + ts + '" value="' + value[0] + '" ' + selected + '>' + ts + '</option>';
                                    //(selected === "selected") ? $(comscore_select_id).parent().find("input.comscore_tv_demo_name_all").val(ts) : $(comscore_select_id).parent().find("input.comscore_tv_demo_name_all").val("M 18-24");
                                    if (selected === "selected")
                                        input_demo_val = ts
                                }
                            }
                            if (demo == 'f') {
                                if (value[2].indexOf('W') !== -1) {
                                    var ts = value[2].replace('W', "F ");
                                    html += '<option title="' + ts + '" value="' + value[0] + '" ' + selected + '>' + ts + '</option>';
                                    //(selected === "selected") ? $(comscore_select_id).parent().find("input.comscore_tv_demo_name_all").val(ts) : $(comscore_select_id).parent().find("input.comscore_tv_demo_name_all").val("F 18-24");
                                    if (selected === "selected")
                                        input_demo_val = ts
                                }
                            }
                        }
                        if (value[12].indexOf('Household Composition') !== -1 && value[2].indexOf("A25") === -1 && value[2].indexOf("A35") === -1) {
                            if (demo == 'hh') {
                                if (html == "") {
                                    var this_selected = (typeof comscore_tv_existing_sec_demo !== "undefined" && comscore_tv_existing_sec_demo !== null && comscore_tv_existing_sec_demo.length > 0 && typeof comscore_tv_existing_sec_demo[position] !== "undefined" && typeof comscore_tv_existing_sec_demo[position].demo_ids !== "undefined" && comscore_tv_existing_sec_demo[position].demo_ids == "all" && typeof comscore_tv_existing_sec_demo[position].demo_type !== "undefined" && comscore_tv_existing_sec_demo[position].demo_type == demo/*typeof comscore_tv_existing_sec_demo.find(elem => elem.demo_ids == value[0]) !== 'undefined'*/) ? "selected" : ""
                                    html += '<option value="all" ' + this_selected + '>---</option>';
                                }
                                html += '<option title="' + value[2] + '" value="' + value[0] + '" ' + selected + '>' + value[2] + '</option>';
                                //(selected === "selected") ? $(comscore_select_id).parent().find("input.comscore_tv_demo_name_all").val(ts) : $(comscore_select_id).parent().find("input.comscore_tv_demo_name_all").val("A25-54 and A65+");
                                if (selected === "selected")
                                    input_demo_val = ts
                            }
                        }
                    });
                    $(comscore_select_id).parent().find("input.comscore_tv_demo_name_all").val(input_demo_val)
                    // if(typeof  comscore_tv_existing_demo !== "undefined" && comscore_tv_existing_demo !== null && comscore_select_id === "#comscore_tv_demo_ids")
                    //     $(comscore_select_id).parent().find("input.demo_comscore_name").val(comscore_tv_existing_demo["demo_name"]);
                    $(comscore_select_id).html(html);
                    $(comscore_select_id).select2().bind('select2:select', function () {
                        var demo_pos = comscore_select_id.split('_')
                        if (typeof demo_pos[4] !== "undefined" && !isNaN(demo_pos[4]))
                            $(this).closest('.comscore-tv-select-demo-container').find('.demo_comscore_name_' + demo_pos[4]).val($(this).find('option[value="' + $(this).val() + '"]').html());
                        else
                            $(this).closest('.comscore-tv-select-demo-container').find('.demo_comscore_name').val($(this).find('option[value="' + $(this).val() + '"]').html());
                    });
                }
            }
        }

        if (typeof nielsen_tv !== 'undefined') {
            if (nielsen_tv !== false) {
                var tv_playback_types = {
                    'LPM': {
                        'LO': 'Live Only',
                        'LS': 'Live Plus Same Day',
                        'L3': 'Live Plus 3',
                        'L7': 'Live Plus 7'
                    },
                    'SRM': {
                        'LS': 'Live Plus Same Day',
                        'L3': 'Live Plus 3',
                        'L7': 'Live Plus 7'
                    },
                    'CRM': {
                        'LS': 'Live Plus Same Day',
                        'L3': 'Live Plus 3',
                        'L7': 'Live Plus 7'
                    },
                    'DIA': {
                        'L1': 'Live Plus 1'
                    }
                };

                var playback_types_all = {
                    'LO': 'Live Only',
                    'LS': 'Live Plus Same Day',
                    'L3': 'Live Plus 3',
                    'L7': 'Live Plus 7',
                    'L1': 'Live Plus 1'
                };

                tv_markets = collect(tv_markets);
                $(document).ready(function () {
                    tv_demos = collect(tv_demos);
                    //radio_demos = collect(radio_demos);

                    show_loader();
                    $.ajax({
                        type: "GET",
                        url: '/ratings/tv/local/markets',
                        dataType: 'json',
                        success: function (data) {
                            nielsen_tv = data;
                            $.each(nielsen_tv, function (index, value) {
                                val = tv_markets.where('code', value['dma']).first();
                                nielsen_tv[index]['slug'] = val['slug'];
                            });
                            nielsen_tv = collect(nielsen_tv);

                            //if(typeof nielsen_tv_existing !== 'undefined'){
                            if (/*nielsen_tv_existing !== false*/typeof actual_markets !== "undefined" && actual_markets.length > 0) {
                                var hide_loader_cont = 0;
                                $.each(/*nielsen_tv_existing*/actual_markets, function (index, market) {
                                    if (market["type"] === "dma") {
                                        $.ajax({
                                            type: "GET",
                                            url: '/ratings/tv/local/monthly/allbooks/?dma=' + market["code"],
                                            dataType: 'json',
                                            //value: value,
                                            success: function (data) {
                                                if (typeof nielsen_tv_markets[market["code"]] === 'undefined') {
                                                    nielsen_tv_markets[market["code"]] = data;
                                                }

                                                console.log("books");
                                                //console.log(data);
                                                console.log(collect(data).keyBy('playback_type').all());
                                                var form_playbacks = collect(data).sortBy('name').keyBy('playback_type').all();

                                                match = nielsen_tv.where('dma', market["code"]).first();
                                                if (typeof match !== "undefined") {
                                                    var html = '<div class="form-inline row market-ratings-container" data-market="' + match['dma'] + '" data-media="tv"><div class="form-group col-md-3 m-b-10"><div class="col-md-12"><input class="form-control full-width nielsen_tv_market" id="nielsen_tv_market" value="' + match['name'] + '" readonly><input type="hidden" name="nielsen_tv_market[]" value="' + match['dma'] + '"/><input type="hidden" name="nielsen_tv_market_name[]" value="' + match['name'] + '"/></div></div><div class="form-group col-md-3 m-b-10"><div class="col-md-12"><select class="form-control full-width" id="nielsen_tv_playback_type" name="nielsen_tv_playback_type[]"><option value="">Choose One...</option>';

                                                    /*$.each(tv_playback_types[match['type']], function (index, value) {
                                                    html += '<option value="' + index + '">' + value + '</option>';
                                                });*/

                                                    $.each(form_playbacks, function (index, value) {
                                                        html += '<option value="' + index + '">' + playback_types_all[index] + '</option>';
                                                    });

                                                    html += '</select></div></div><div class="form-group col-md-3 m-b-10"><div class="col-md-12"><select class="form-control full-width" id="nielsen_tv_share" name="nielsen_tv_share[]"></select><input type="hidden" name="nielsen_tv_share_name[]" value=""></div></div><div class="form-group col-md-3 m-b-10"><div class="col-md-12"><select class="form-control full-width" id="nielsen_tv_hut" name="nielsen_tv_hut[]"></select><input type="hidden" name="nielsen_tv_hut_name[]" value=""></div></div></div>';
                                                    var container = $('#nielsen_tv_books').find('.books_container');
                                                    $(html).find('#nielsen_tv_market').val(match['name']);

                                                    container.append(html);

                                                    container.find('div.row[data-market="' + match['dma'] + '"] select[name="nielsen_tv_playback_type[]"]').bind('change', function () {
                                                        marketMultiSelectNielsenPlaybackChange(this);
                                                    });
                                                    var index_exist = nielsen_tv_existing.findIndex(elem => market["code"] === elem.dma)
                                                    if (index_exist !== -1)
                                                        container.find('div.row[data-market="' + match['dma'] + '"] #nielsen_tv_playback_type').val(nielsen_tv_existing[index_exist]['playback_type']);

                                                    marketMultiSelectNielsenPlaybackChange(container.find('div.row[data-market="' + match['dma'] + '"] #nielsen_tv_playback_type'));
                                                    if (index_exist !== -1) {
                                                        container.find('div.row[data-market="' + match['dma'] + '"] #nielsen_tv_share').val(nielsen_tv_existing[index_exist]['share']).trigger('change.select2');
                                                        container.find('div.row[data-market="' + match['dma'] + '"] #nielsen_tv_hut').val(nielsen_tv_existing[index_exist]['hut']).trigger('change.select2');
                                                    }
                                                    //$('#nielsen_tv_books').removeClass('hidden').addClass('shown');
                                                }
                                                hide_loader_cont++
                                                if (actual_markets.length == hide_loader_cont)
                                                    hide_loader();
                                            },
                                            error: function (xhr) {
                                                ajax_error();
                                                debug(xhr.responseText);
                                                hide_loader();
                                            }
                                        });
                                    } else {
                                        hide_loader_cont++
                                        if (actual_markets.length == hide_loader_cont)
                                            hide_loader();
                                    }
                                });

                                $('.tv-select-demo-container input[type="radio"]').on('change', function () {
                                    var rid = $(this).attr('id');
                                    rid = rid.split("_");
                                    rid = rid[rid.length - 1];
                                    if (isNaN(parseInt(rid))) {
                                        var demo_type = $(this).val();
                                        console.log(demo_type);
                                        console.log(demo_type);
                                        console.log('------tv_demos-----', tv_demos);
                                        var select = $($(this).closest('.tv-select-demo-container').find('select')[0]);
                                        select.html('');
                                        select.attr('disabled', null);

                                        if (demo_type === 'hh') {
                                            select.append('<option value="hh" selected>-</option>');
                                            $(this).closest('.tv-select-demo-container').find('.demo_name')
                                                .val('hh');
                                            select.attr('readonly', 'readonly');
                                        } else if (demo_type === '') {
                                            select.append('<option value="" selected>-</option>');
                                            select.attr('disabled', 'disabled');
                                        } else if (demo_type === 'p') {
                                            tv_demos.each(function (item) {
                                                var ids = "";
                                                var string = "";
                                                console.log('------tv_demos-----', item);
                                                $.each(item['blocks']['p'], function (index, value) {
                                                    ids += value.toString() + ',';
                                                });
                                                if (item['end'] === null) {
                                                    string = item['start'] + "+";
                                                } else {
                                                    string = item['start'] + "-" + item['end'];
                                                }

                                                select.append('<option value="' + ids + '">' + string + '</option>');
                                            });
                                        } else if (demo_type === 'f') {
                                            tv_demos.each(function (item) {
                                                var ids = "";
                                                var string = "";
                                                $.each(item['blocks']['f'], function (index, value) {
                                                    ids += value.toString() + ',';
                                                });
                                                if (item['end'] === null) {
                                                    string = item['start'] + "+";
                                                } else {
                                                    string = item['start'] + "-" + item['end'];
                                                }

                                                select.append('<option value="' + ids + '">' + string + '</option>');
                                            });
                                        } else {
                                            tv_demos.each(function (item) {
                                                if ((item['start'] !== 6) && (item['start'] !== 2)) {
                                                    var ids = "";
                                                    var string = "";
                                                    $.each(item['blocks']['m'], function (index, value) {
                                                        ids += value.toString() + ',';
                                                    });
                                                    if (item['end'] === null) {
                                                        string = item['start'] + "+";
                                                    } else {
                                                        string = item['start'] + "-" + item['end'];
                                                    }

                                                    select.append('<option value="' + ids + '">' + string + '</option>');
                                                }
                                            });
                                        }
                                    }
                                });
                            }
                            //}

                            $('#nielsen_tv_demo_ids').select2({
                                placeholder: "...",
                                minimumResultsForSearch: 10
                            }).bind('select2:select', function () {
                                console.log($(this).closest('.tv-select-demo-container').find('.demo_name'));
                                $(this).closest('.tv-select-demo-container').find('.demo_name').val($(this).find('option[value="' + $(this).val() + '"]').html());
                            });
                            $(".select2-selection.select2-selection--multiple:not(:has(i.fa.fa-search.search-icon-input))").prepend("<i class='fa fa-search search-icon-input'></i>")

                            //comscore
                            $('#comscore_tv_demo_ids').select2({
                                placeholder: "...",
                                minimumResultsForSearch: 10
                            }).bind('select2:select', function () {
                                console.log("change1");
                                //console.log($(this).closest('.tv-select-demo-container').find('.demo_name'));
                                $(this).closest('.comscore-tv-select-demo-container').find('.demo_comscore_name').val($(this).find('option[value="' + $(this).val() + '"]').html());
                            });

                            if (typeof nielsen_tv_existing_demo !== 'undefined' && nielsen_tv_existing_demo !== null) {
                                if ((nielsen_tv_existing_demo !== false) && (nielsen_tv_existing_demo !== null)) {
                                    container = $('#nielsen_tv_demographics');
                                    console.log(nielsen_tv_existing_demo);

                                    container.find('input[name="nielsen_tv_demo_type"][value="' + nielsen_tv_existing_demo['demo_type'] + '"]').prop("checked", true).trigger('change');
                                    container.find('select[name="nielsen_tv_demo_ids"] option[value="' + nielsen_tv_existing_demo['demo_ids'] + '"]').prop('selected', 'selected').trigger('change.select2');
                                    $('.tv-select-demo-container').find('.demo_name').val(nielsen_tv_existing_demo['demo_name']);
                                }
                            }
                            if (typeof comscore_tv_existing_demo !== 'undefined' && comscore_tv_existing_demo !== null) {
                                $('#comscore_dat input[name="comscore_tv_demo_type"][value="' + comscore_tv_existing_demo['demo_type'] + '"]').prop("checked", true).trigger('change');
                                // $('#comscore_dat select[name="comscore_tv_demo_ids"] option[value="' + comscore_tv_existing_demo['demo_ids'] + '"]').prop('selected', 'selected').trigger('change.select2');
                                $('#comscore_dat .comscore-tv-select-demo-container').find('.demo_comscore_name').val(comscore_tv_existing_demo['demo_name']);
                            }
                            if (typeof nielsen_tv_existing_sec_demo !== 'undefined') {
                                if ((nielsen_tv_existing_sec_demo !== false) && (nielsen_tv_existing_sec_demo !== null)) {

                                    for (var i = 1; i < nielsen_tv_existing_sec_demo.length; i++) {
                                        var aux_demo = nielsen_tv_existing_sec_demo[i];
                                        container = $('#nielsen_tv_demographics');
                                        console.log(aux_demo);

                                        container.find('input[name="nielsen_tv_demo_type_' + i + '"][value="' + aux_demo['demo_type'] + '"]').prop("checked", true).trigger('change');
                                        container.find('select[name="nielsen_tv_demo_ids_' + i + '"] option[value="' + aux_demo['demo_ids'] + '"]').prop('selected', 'selected').trigger('change.select2');
                                        $('.tv-select-demo-container').find('.demo_name_' + i).val(aux_demo['demo_name']);
                                    }

                                }
                            }
                            if (typeof actual_markets === "undefined" || actual_markets.length <= 0)
                                hide_loader();
                        },
                        error: function (xhr) {
                            ajax_error();
                            debug(xhr.responseText);
                            hide_loader();
                        }
                    });

                    $('.tv-select-demo-container input[type="radio"]').on('change', function () {
                        var rid = $(this).attr('id');
                        rid = rid.split("_");
                        rid = rid[rid.length - 1];
                        if (!isNaN(parseInt(rid))) {
                            var demo_type = $(this).val();
                            console.log(demo_type);
                            console.log(demo_type);
                            console.log('------tv_demos-----', tv_demos);
                            var select = $("#nielsen_tv_demo_ids_" + rid);
                            select.html('');
                            select.attr('disabled', null);

                            if (demo_type === 'hh') {
                                select.append('<option value="hh" selected>-</option>');
                                $(this).closest('.tv-select-demo-container').find('.demo_name_' + rid)
                                    .val('hh');
                                select.attr('readonly', 'readonly');
                            } else if (demo_type === '') {
                                select.append('<option value="" selected>-</option>');
                                select.attr('disabled', 'disabled');
                            } else if (demo_type === 'p') {
                                tv_demos.each(function (item) {
                                    var ids = "";
                                    var string = "";
                                    console.log('------tv_demos-----', item);
                                    $.each(item['blocks']['p'], function (index, value) {
                                        ids += value.toString() + ',';
                                    });
                                    if (item['end'] === null) {
                                        string = item['start'] + "+";
                                    } else {
                                        string = item['start'] + "-" + item['end'];
                                    }

                                    select.append('<option value="' + ids + '">' + string + '</option>');
                                });
                            } else if (demo_type === 'f') {
                                tv_demos.each(function (item) {
                                    var ids = "";
                                    var string = "";
                                    $.each(item['blocks']['f'], function (index, value) {
                                        ids += value.toString() + ',';
                                    });
                                    if (item['end'] === null) {
                                        string = item['start'] + "+";
                                    } else {
                                        string = item['start'] + "-" + item['end'];
                                    }

                                    select.append('<option value="' + ids + '">' + string + '</option>');
                                });
                            } else {
                                tv_demos.each(function (item) {
                                    if ((item['start'] !== 6) && (item['start'] !== 2)) {
                                        var ids = "";
                                        var string = "";
                                        $.each(item['blocks']['m'], function (index, value) {
                                            ids += value.toString() + ',';
                                        });
                                        if (item['end'] === null) {
                                            string = item['start'] + "+";
                                        } else {
                                            string = item['start'] + "-" + item['end'];
                                        }

                                        select.append('<option value="' + ids + '">' + string + '</option>');
                                    }
                                });
                            }

                            $('#nielsen_tv_demo_ids_' + rid).select2({
                                placeholder: "...",
                                minimumResultsForSearch: 10
                            }).bind('select2:select', function () {
                                console.log($(this).closest('.tv-select-demo-container').find('.demo_name_' + rid));
                                $(this).closest('.tv-select-demo-container').find('.demo_name_' + rid).val($(this).find('option[value="' + $(this).val() + '"]').html());
                            });
                            $(".select2-selection.select2-selection--multiple:not(:has(i.fa.fa-search.search-icon-input))").prepend("<i class='fa fa-search search-icon-input'></i>")
                        }
                    });

                    $('.radio-select-demo-container input[type="radio"]').on('change', function () {
                        var rid = $(this).attr('id');
                        rid = rid.split("_");
                        rid = rid[rid.length - 1];
                        if (!isNaN(parseInt(rid))) {
                            var demo_type = $(this).val();
                            var select = $("#nielsen_radio_demo_ids_" + rid);
                            select.html('');
                            select.attr('disabled', null);

                            if (demo_type === '') {
                                select.append('<option value="" selected>-</option>');
                                select.attr('disabled', 'disabled');
                            } else if (demo_type === 'p') {
                                radio_demos.each(function (item) {
                                    var ids = "";
                                    var string = "";
                                    $.each(item['blocks']['p'], function (index, value) {
                                        ids += value.toString() + ',';
                                    });
                                    if (item['end'] === null) {
                                        string = item['start'] + "+";
                                    } else {
                                        string = item['start'] + "-" + item['end'];
                                    }

                                    select.append('<option value="' + ids + '">' + string + '</option>');
                                });
                            } else {
                                radio_demos.each(function (item) {
                                    var ids = "";
                                    var string = "";
                                    $.each(item['blocks'][demo_type], function (index, value) {
                                        ids += value.toString() + ',';
                                    });
                                    if (item['end'] === null) {
                                        string = item['start'] + "+";
                                    } else {
                                        string = item['start'] + "-" + item['end'];
                                    }

                                    select.append('<option value="' + ids + '">' + string + '</option>');
                                });
                            }

                            $('#nielsen_radio_demo_ids_' + rid).select2({
                                placeholder: "...",
                                minimumResultsForSearch: 10
                            }).bind('select2:select', function () {
                                console.log("<<<<");
                                console.log(this);
                                $(this).closest('.radio-select-demo-container').find('.demo_name_' + rid)
                                    .val($(this).find('option[value="' + $(this).val() + '"]').html());
                            });
                            $(".select2-selection.select2-selection--multiple:not(:has(i.fa.fa-search.search-icon-input))").prepend("<i class='fa fa-search search-icon-input'></i>")
                        }
                    });

                });

                var nielsen_tv_markets = {};

                $('.tv-select-demo-container input[type="radio"]').on('change', function () {
                    var rid = $(this).attr('id');
                    rid = rid.split("_");
                    rid = rid[rid.length - 1];
                    if (isNaN(parseInt(rid))) {
                        var demo_type = $(this).val();
                        console.log(demo_type);
                        var select = $($(this).closest('.tv-select-demo-container').find('select')[0]);
                        select.html('');
                        select.attr('disabled', null);

                        if (demo_type === 'hh') {
                            select.append('<option value="hh" selected>-</option>');
                            $(this).closest('.tv-select-demo-container').find('.demo_name')
                                .val('hh');
                            select.attr('readonly', 'readonly');
                        } else if (demo_type === '') {
                            select.append('<option value="" selected>-</option>');
                            select.attr('disabled', 'disabled');
                        } else if (demo_type === 'p') {
                            tv_demos.each(function (item) {
                                var ids = "";
                                var string = "";
                                $.each(item['blocks']['p'], function (index, value) {
                                    ids += value.toString() + ',';
                                });
                                if (item['end'] === null) {
                                    string = item['start'] + "+";
                                } else {
                                    string = item['start'] + "-" + item['end'];
                                }

                                select.append('<option value="' + ids + '">' + string + '</option>');
                            });
                        } else if (demo_type === 'f') {
                            tv_demos.each(function (item) {
                                var ids = "";
                                var string = "";
                                $.each(item['blocks']['f'], function (index, value) {
                                    ids += value.toString() + ',';
                                });
                                if (item['end'] === null) {
                                    string = item['start'] + "+";
                                } else {
                                    string = item['start'] + "-" + item['end'];
                                }

                                select.append('<option value="' + ids + '">' + string + '</option>');
                            });
                        } else {
                            tv_demos.each(function (item) {
                                if ((item['start'] !== 6) && (item['start'] !== 2)) {
                                    var ids = "";
                                    var string = "";
                                    $.each(item['blocks']['m'], function (index, value) {
                                        ids += value.toString() + ',';
                                    });
                                    if (item['end'] === null) {
                                        string = item['start'] + "+";
                                    } else {
                                        string = item['start'] + "-" + item['end'];
                                    }

                                    select.append('<option value="' + ids + '">' + string + '</option>');
                                }
                            });
                        }
                    }
                });

            } else {
                var tv_demos = collect(tv_demos);
                $('.tv-select-demo-container input[type="radio"]').on('change', function () {
                    var rid = $(this).attr('id');
                    rid = rid.split("_");
                    rid = rid[rid.length - 1];
                    if (isNaN(parseInt(rid))) {
                        var demo_type = $(this).val();
                        console.log(demo_type);
                        console.log(demo_type);
                        console.log('------tv_demos-----', tv_demos);
                        var select = $($(this).closest('.tv-select-demo-container').find('select')[0]);
                        select.html('');
                        select.attr('disabled', null);

                        if (demo_type === 'hh') {
                            select.append('<option value="hh" selected>-</option>');
                            $(this).closest('.tv-select-demo-container').find('.demo_name')
                                .val('hh');
                            select.attr('readonly', 'readonly');
                        } else if (demo_type === '') {
                            select.append('<option value="" selected>-</option>');
                            select.attr('disabled', 'disabled');
                        } else if (demo_type === 'p') {
                            tv_demos.each(function (item) {
                                var ids = "";
                                var string = "";
                                console.log('------tv_demos-----', item);
                                $.each(item['blocks']['p'], function (index, value) {
                                    ids += value.toString() + ',';
                                });
                                if (item['end'] === null) {
                                    string = item['start'] + "+";
                                } else {
                                    string = item['start'] + "-" + item['end'];
                                }

                                select.append('<option value="' + ids + '">' + string + '</option>');
                            });
                        } else if (demo_type === 'f') {
                            tv_demos.each(function (item) {
                                var ids = "";
                                var string = "";
                                $.each(item['blocks']['f'], function (index, value) {
                                    ids += value.toString() + ',';
                                });
                                if (item['end'] === null) {
                                    string = item['start'] + "+";
                                } else {
                                    string = item['start'] + "-" + item['end'];
                                }

                                select.append('<option value="' + ids + '">' + string + '</option>');
                            });
                        } else {
                            tv_demos.each(function (item) {
                                if ((item['start'] !== 6) && (item['start'] !== 2)) {
                                    var ids = "";
                                    var string = "";
                                    $.each(item['blocks']['m'], function (index, value) {
                                        ids += value.toString() + ',';
                                    });
                                    if (item['end'] === null) {
                                        string = item['start'] + "+";
                                    } else {
                                        string = item['start'] + "-" + item['end'];
                                    }

                                    select.append('<option value="' + ids + '">' + string + '</option>');
                                }
                            });
                        }
                    }
                });
                $('#nielsen_tv_demo_ids').select2({
                    placeholder: "...",
                    minimumResultsForSearch: 10
                }).bind('select2:select', function () {
                    console.log($(this).closest('.tv-select-demo-container').find('.demo_name'));
                    $(this).closest('.tv-select-demo-container').find('.demo_name').val($(this).find('option[value="' + $(this).val() + '"]').html());
                });
                $(".select2-selection.select2-selection--multiple:not(:has(i.fa.fa-search.search-icon-input))").prepend("<i class='fa fa-search search-icon-input'></i>")
                if (typeof nielsen_tv_existing_demo !== 'undefined') {
                    if ((nielsen_tv_existing_demo !== false) && (nielsen_tv_existing_demo !== null)) {
                        container = $('#nielsen_tv_demographics');
                        console.log(nielsen_tv_existing_demo);

                        container.find('input[name="nielsen_tv_demo_type"][value="' + nielsen_tv_existing_demo['demo_type'] + '"]').prop("checked", true).trigger('change');
                        container.find('select[name="nielsen_tv_demo_ids"] option[value="' + nielsen_tv_existing_demo['demo_ids'] + '"]').prop('selected', 'selected').trigger('change.select2');
                        $('.tv-select-demo-container').find('.demo_name').val(nielsen_tv_existing_demo['demo_name']);
                    }
                }
                if (typeof nielsen_tv_existing_sec_demo !== 'undefined') {
                    if ((nielsen_tv_existing_sec_demo !== false) && (nielsen_tv_existing_sec_demo !== null)) {

                        for (var i = 1; i < nielsen_tv_existing_sec_demo.length; i++) {
                            var aux_demo = nielsen_tv_existing_sec_demo[i];
                            container = $('#nielsen_tv_demographics');
                            console.log(aux_demo);

                            container.find('input[name="nielsen_tv_demo_type_' + i + '"][value="' + aux_demo['demo_type'] + '"]').prop("checked", true).trigger('change');
                            container.find('select[name="nielsen_tv_demo_ids_' + i + '"] option[value="' + aux_demo['demo_ids'] + '"]').prop('selected', 'selected').trigger('change.select2');
                            $('.tv-select-demo-container').find('.demo_name_' + i).val(aux_demo['demo_name']);
                        }

                    }
                }
            }
        } else {
            var tv_demos = collect(tv_demos);
            $('.tv-select-demo-container input[type="radio"]').on('change', function () {
                var rid = $(this).attr('id');
                rid = rid.split("_");
                rid = rid[rid.length - 1];
                if (isNaN(parseInt(rid))) {
                    var demo_type = $(this).val();
                    console.log(demo_type);
                    console.log('------tv_demos-----', tv_demos);
                    var select = $($(this).closest('.tv-select-demo-container').find('select')[0]);
                    select.html('');
                    select.attr('disabled', null);

                    if (demo_type === 'hh') {
                        select.append('<option value="hh" selected>-</option>');
                        $(this).closest('.tv-select-demo-container').find('.demo_name')
                            .val('hh');
                        select.attr('readonly', 'readonly');
                    } else if (demo_type === '') {
                        select.append('<option value="" selected>-</option>');
                        select.attr('disabled', 'disabled');
                    } else if (demo_type === 'p') {
                        tv_demos.each(function (item) {
                            var ids = "";
                            var string = "";
                            $.each(item['blocks']['p'], function (index, value) {
                                ids += value.toString() + ',';
                            });
                            if (item['end'] === null) {
                                string = item['start'] + "+";
                            } else {
                                string = item['start'] + "-" + item['end'];
                            }

                            select.append('<option value="' + ids + '">' + string + '</option>');
                        });
                    } else if (demo_type === 'f') {
                        tv_demos.each(function (item) {
                            var ids = "";
                            var string = "";
                            console.log('------item-----', item);
                            $.each(item['blocks']['f'], function (index, value) {
                                ids += value.toString() + ',';
                            });
                            if (item['end'] === null) {
                                string = item['start'] + "+";
                            } else {
                                string = item['start'] + "-" + item['end'];
                            }

                            select.append('<option value="' + ids + '">' + string + '</option>');
                        });
                    } else {
                        tv_demos.each(function (item) {
                            if ((item['start'] !== 6) && (item['start'] !== 2)) {
                                var ids = "";
                                var string = "";
                                $.each(item['blocks']['m'], function (index, value) {
                                    ids += value.toString() + ',';
                                });
                                if (item['end'] === null) {
                                    string = item['start'] + "+";
                                } else {
                                    string = item['start'] + "-" + item['end'];
                                }

                                select.append('<option value="' + ids + '">' + string + '</option>');
                            }
                        });
                    }
                }
            });
            $('#nielsen_tv_demo_ids').select2({
                placeholder: "...",
                minimumResultsForSearch: 10
            }).bind('select2:select', function () {
                console.log($(this).closest('.tv-select-demo-container').find('.demo_name'));
                $(this).closest('.tv-select-demo-container').find('.demo_name').val($(this).find('option[value="' + $(this).val() + '"]').html());
            });
            $(".select2-selection.select2-selection--multiple:not(:has(i.fa.fa-search.search-icon-input))").prepend("<i class='fa fa-search search-icon-input'></i>")
            if (typeof nielsen_tv_existing_demo !== 'undefined') {
                if ((nielsen_tv_existing_demo !== false) && (nielsen_tv_existing_demo !== null)) {
                    container = $('#nielsen_tv_demographics');
                    console.log(nielsen_tv_existing_demo);

                    container.find('input[name="nielsen_tv_demo_type"][value="' + nielsen_tv_existing_demo['demo_type'] + '"]').prop("checked", true).trigger('change');
                    container.find('select[name="nielsen_tv_demo_ids"] option[value="' + nielsen_tv_existing_demo['demo_ids'] + '"]').prop('selected', 'selected').trigger('change.select2');
                    $('.tv-select-demo-container').find('.demo_name').val(nielsen_tv_existing_demo['demo_name']);
                }
            }
            if (typeof nielsen_tv_existing_sec_demo !== 'undefined') {
                if ((nielsen_tv_existing_sec_demo !== false) && (nielsen_tv_existing_sec_demo !== null)) {

                    for (var i = 1; i < nielsen_tv_existing_sec_demo.length; i++) {
                        var aux_demo = nielsen_tv_existing_sec_demo[i];
                        container = $('#nielsen_tv_demographics');
                        console.log(aux_demo);

                        container.find('input[name="nielsen_tv_demo_type_' + i + '"][value="' + aux_demo['demo_type'] + '"]').prop("checked", true).trigger('change');
                        container.find('select[name="nielsen_tv_demo_ids_' + i + '"] option[value="' + aux_demo['demo_ids'] + '"]').prop('selected', 'selected').trigger('change.select2');
                        $('.tv-select-demo-container').find('.demo_name_' + i).val(aux_demo['demo_name']);
                    }

                }
            }
        }


        $("#add_camp_demo_tv").on("click", function () {
            var container = $(".tv-select-demo-container");
            var parents = container.children().length;
            console.log(container.children());
            console.log(parents);
            container.append('' +
                '<div class="row">\n' +
                '                            <div class="col-md-4">\n' +
                '                                <div class="radio radio-primary">\n' +
                '                                    <input type="radio" name="nielsen_tv_demo_type_' + parents + '"\n' +
                '                                           id="nielsen_tv_demo_type_hh_' + parents + '" value="hh"\n' +
                '                                           >\n' +
                '                                    <label for="nielsen_tv_demo_type_hh_' + parents + '">\n' +
                '                                        &nbsp;HH</label>\n' +
                '                                </div>\n' +
                '                                <div class="radio radio-primary">\n' +
                '                                    <input type="radio" name="nielsen_tv_demo_type_' + parents + '"\n' +
                '                                           id="nielsen_tv_demo_type_p_' + parents + '" value="p"\n' +
                '                                           checked>\n' +
                '                                    <label for="nielsen_tv_demo_type_p_' + parents + '">\n' +
                '                                        &nbsp;P</label>\n' +
                '                                </div>\n' +
                '                                <div class="radio radio-primary">\n' +
                '                                    <input type="radio" name="nielsen_tv_demo_type_' + parents + '"\n' +
                '                                           id="nielsen_tv_demo_type_m_' + parents + '" value="m">\n' +
                '                                    <label for="nielsen_tv_demo_type_m_' + parents + '">\n' +
                '                                        &nbsp;M</label>\n' +
                '                                </div>\n' +
                '                                <div class="radio radio-primary">\n' +
                '                                    <input type="radio" name="nielsen_tv_demo_type_' + parents + '"\n' +
                '                                           id="nielsen_tv_demo_type_f_' + parents + '" value="f">\n' +
                '                                    <label for="nielsen_tv_demo_type_f_' + parents + '">\n' +
                '                                        &nbsp;F</label>\n' +
                '                                </div>\n' +
                '                            </div>\n' +
                '                            <div class="col-md-3">\n' +
                '                                <select class="form-control full-width select2-hidden-accessible" name="nielsen_tv_demo_ids_' + parents + '" id="nielsen_tv_demo_ids_' + parents + '" tabindex="-1" aria-hidden="true"><option value="1,">2-5</option><option value="1,2,">2-11</option><option value="1,2,3,12,">2-14</option><option value="1,2,3,4,12,13,">2-17</option><option value="1,2,3,4,5,12,13,14,">2-20</option><option value="1,2,3,4,5,6,12,13,14,15,">2-24</option><option value="1,2,3,4,5,6,7,12,13,14,15,16,">2-34</option><option value="1,2,3,4,5,6,7,8,12,13,14,15,16,17,">2-49</option><option value="1,2,3,4,5,6,7,8,9,12,13,14,15,16,17,18,">2-54</option><option value="1,2,3,4,5,6,7,8,9,10,12,13,14,15,16,17,18,19,">2-64</option><option value="1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,">2+</option><option value="2,">6-11</option><option value="2,3,12,">6-14</option><option value="2,3,4,12,13,">6-17</option><option value="2,3,4,5,12,13,14,">6-20</option><option value="2,3,4,5,6,12,13,14,15,">6-24</option><option value="2,3,4,5,6,7,12,13,14,15,16,">6-34</option><option value="2,3,4,5,6,7,8,12,13,14,15,16,17,">6-49</option><option value="2,3,4,5,6,7,8,9,12,13,14,15,16,17,18,">6-54</option><option value="2,3,4,5,6,7,8,9,10,12,13,14,15,16,17,18,19,">6-64</option><option value="2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,">6+</option><option value="3,12,">12-14</option><option value="3,4,12,13,">12-17</option><option value="3,4,5,12,13,14,">12-20</option><option value="3,4,5,6,12,13,14,15,">12-24</option><option value="3,4,5,6,7,12,13,14,15,16,">12-34</option><option value="3,4,5,6,7,8,12,13,14,15,16,17,">12-49</option><option value="3,4,5,6,7,8,9,12,13,14,15,16,17,18,">12-54</option><option value="3,4,5,6,7,8,9,10,12,13,14,15,16,17,18,19,">12-64</option><option value="3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,">12+</option><option value="4,13,">15-17</option><option value="4,5,13,14,">15-20</option><option value="4,5,6,13,14,15,">15-24</option><option value="4,5,6,7,13,14,15,16,">15-34</option><option value="4,5,6,7,8,13,14,15,16,17,">15-49</option><option value="4,5,6,7,8,9,13,14,15,16,17,18,">15-54</option><option value="4,5,6,7,8,9,10,13,14,15,16,17,18,19,">15-64</option><option value="4,5,6,7,8,9,10,11,13,14,15,16,17,18,19,20,">15+</option><option value="5,14,">18-20</option><option value="5,6,14,15,">18-24</option><option value="5,6,7,14,15,16,">18-34</option><option value="5,6,7,8,14,15,16,17,">18-49</option><option value="5,6,7,8,9,14,15,16,17,18,">18-54</option><option value="5,6,7,8,9,10,14,15,16,17,18,19,">18-64</option><option value="5,6,7,8,9,10,11,14,15,16,17,18,19,20,">18+</option><option value="6,15,">21-24</option><option value="6,7,15,16,">21-34</option><option value="6,7,8,15,16,17,">21-49</option><option value="6,7,8,9,15,16,17,18,">21-54</option><option value="6,7,8,9,10,15,16,17,18,19,">21-64</option><option value="6,7,8,9,10,11,15,16,17,18,19,20,">21+</option><option value="7,16,">25-34</option><option value="7,8,16,17,">25-49</option><option value="7,8,9,16,17,18,">25-54</option><option value="7,8,9,10,16,17,18,19,">25-64</option><option value="7,8,9,10,11,16,17,18,19,20,">25+</option><option value="8,17,">35-49</option><option value="8,9,17,18,">35-54</option><option value="8,9,10,17,18,19,">35-64</option><option value="8,9,10,11,17,18,19,20,">35+</option><option value="9,18,">50-54</option><option value="9,10,18,19,">50-64</option><option value="9,10,11,18,19,20,">50+</option><option value="10,19,">55-64</option><option value="10,11,19,20,">55+</option><option value="11,20,">65+</option></select>' +
                '                                <input name="nielsen_tv_demo_name_' + parents + '" value="25-54" class="demo_name_' + parents + '"\n' +
                '                                       type="hidden"/>\n' +
                '                            </div>\n' +
                '<div class="col-md-3">\n' +
                '                                <button style="border-color: red; color:red" type="button" class="btn btn-error btn-outline del_camp_demo_tv" > <i class="fa fa-trash"></i> Remove</button>\n' +
                '                            </div>' +
                '                        </div>' +
                '');
            $(".del_camp_demo_tv").on('click', function () {
                console.log("click tv");
                $(this).parent().parent().remove();
            });

            $('.tv-select-demo-container input[type="radio"]').on('change', function () {
                var rid = $(this).attr('id');
                rid = rid.split("_");
                rid = rid[rid.length - 1];
                if (!isNaN(parseInt(rid))) {
                    var demo_type = $(this).val();
                    console.log(demo_type);
                    var select = $("#nielsen_tv_demo_ids_" + rid);
                    select.html('');
                    select.attr('disabled', null);

                    if (demo_type === 'hh') {
                        select.append('<option value="hh" selected>-</option>');
                        $(this).closest('.tv-select-demo-container').find('.demo_name_' + rid)
                            .val('hh');
                        select.attr('readonly', 'readonly');
                    } else if (demo_type === '') {
                        select.append('<option value="" selected>-</option>');
                        select.attr('disabled', 'disabled');
                    } else if (demo_type === 'p') {
                        tv_demos.each(function (item) {
                            var ids = "";
                            var string = "";
                            $.each(item['blocks']['p'], function (index, value) {
                                ids += value.toString() + ',';
                            });
                            if (item['end'] === null) {
                                string = item['start'] + "+";
                            } else {
                                string = item['start'] + "-" + item['end'];
                            }

                            select.append('<option value="' + ids + '">' + string + '</option>');
                        });
                    } else if (demo_type === 'f') {
                        tv_demos.each(function (item) {
                            var ids = "";
                            var string = "";
                            $.each(item['blocks']['f'], function (index, value) {
                                ids += value.toString() + ',';
                            });
                            if (item['end'] === null) {
                                string = item['start'] + "+";
                            } else {
                                string = item['start'] + "-" + item['end'];
                            }

                            select.append('<option value="' + ids + '">' + string + '</option>');
                        });
                    } else {
                        tv_demos.each(function (item) {
                            if ((item['start'] !== 6) && (item['start'] !== 2)) {
                                var ids = "";
                                var string = "";
                                $.each(item['blocks']['m'], function (index, value) {
                                    ids += value.toString() + ',';
                                });
                                if (item['end'] === null) {
                                    string = item['start'] + "+";
                                } else {
                                    string = item['start'] + "-" + item['end'];
                                }

                                select.append('<option value="' + ids + '">' + string + '</option>');
                            }
                        });
                    }
                }//);
                $('#nielsen_tv_demo_ids').select2({
                    placeholder: "...",
                    minimumResultsForSearch: 10
                }).bind('select2:select', function () {
                    console.log($(this).closest('.tv-select-demo-container').find('.demo_name'));
                    $(this).closest('.tv-select-demo-container').find('.demo_name').val($(this).find('option[value="' + $(this).val() + '"]').html());
                });
                if (typeof nielsen_tv_existing_demo !== 'undefined' && nielsen_tv_existing_demo !== null) {
                    if ((nielsen_tv_existing_demo !== false) && (nielsen_tv_existing_demo !== null)) {
                        container = $('#nielsen_tv_demographics');
                        console.log(nielsen_tv_existing_demo);
                    }
                    $('#nielsen_tv_demo_ids_' + rid).select2({
                        placeholder: "...",
                        minimumResultsForSearch: 10
                    }).bind('select2:select', function () {
                        console.log($(this).closest('.tv-select-demo-container').find('.demo_name_' + rid));
                        $(this).closest('.tv-select-demo-container').find('.demo_name_' + rid).val($(this).find('option[value="' + $(this).val() + '"]').html());
                    });
                    $(".select2-selection.select2-selection--multiple:not(:has(i.fa.fa-search.search-icon-input))").prepend("<i class='fa fa-search search-icon-input'></i>")
                }
            });

            $('#nielsen_tv_demo_ids_' + parents).select2({
                placeholder: "...",
                minimumResultsForSearch: 10
            }).bind('select2:select', function () {
                console.log("<<<<");
                console.log(this);
                $(this).closest('.tv-select-demo-container').find('.demo_name_' + parents)
                    .val($(this).find('option[value="' + $(this).val() + '"]').html());
            });
            $(".select2-selection.select2-selection--multiple:not(:has(i.fa.fa-search.search-icon-input))").prepend("<i class='fa fa-search search-icon-input'></i>")
        });

        $("#add_camp_demo_comscore").on("click", function () {
            var container = $(".comscore-tv-select-demo-container");
            var parents = container.children().length;
            console.log(container.children());
            console.log(parents);

            container.append('' +
                '<div class="row">\n' +
                '                            <div class="col-md-4">\n' +
                '                                <div class="radio radio-primary">\n' +
                '                                    <input type="radio" name="comscore_tv_demo_type_' + parents + '"\n' +
                '                                           id="comscore_tv_demo_type_hh_' + parents + '" value="hh"\n' +
                '                                           checked>\n' +
                '                                    <label for="comscore_tv_demo_type_hh_' + parents + '">\n' +
                '                                        &nbsp;HH</label>\n' +
                '                                </div>\n' +

                '                                <div class="radio radio-primary">\n' +
                '                                    <input type="radio" name="comscore_tv_demo_type_' + parents + '"\n' +
                '                                           id="comscore_tv_demo_type_p_' + parents + '" value="p"\n' +
                '                                           checked>\n' +
                '                                    <label for="comscore_tv_demo_type_p_' + parents + '">\n' +
                '                                        &nbsp;P</label>\n' +
                '                                </div>\n' +
                '                                <div class="radio radio-primary">\n' +
                '                                    <input type="radio" name="comscore_tv_demo_type_' + parents + '"\n' +
                '                                           id="comscore_tv_demo_type_m_' + parents + '" value="m">\n' +
                '                                    <label for="comscore_tv_demo_type_m_' + parents + '">\n' +
                '                                        &nbsp;M</label>\n' +
                '                                </div>\n' +
                '                                <div class="radio radio-primary">\n' +
                '                                    <input type="radio" name="comscore_tv_demo_type_' + parents + '"\n' +
                '                                           id="comscore_tv_demo_type_f_' + parents + '" value="f">\n' +
                '                                    <label for="comscore_tv_demo_type_f_' + parents + '">\n' +
                '                                        &nbsp;F</label>\n' +
                '                                </div>\n' +
                '                            </div>\n' +
                '                            <div class="col-md-3">\n' +
                '                                <select class="form-control full-width select2-hidden-accessible" name="comscore_tv_demo_ids_' + parents + '" id="comscore_tv_demo_ids_' + parents + '" tabindex="-1" aria-hidden="true"></select>' +
                '                                <input name="comscore_tv_demo_name_' + parents + '" value="P 18-24" class="comscore_tv_demo_name_all demo_comscore_name_' + parents + '"\n' +
                '                                       type="hidden"/>\n' +
                '                            </div>\n' +
                '<div class="col-md-3">\n' +
                '                                <button style="border-color: red; color:red" type="button" class="btn btn-error btn-outline del_camp_demo_tv" > <i class="fa fa-trash"></i> Remove</button>\n' +
                '                            </div>' +
                '                        </div>' +
                '');
            $(".del_camp_demo_tv").on('click', function () {
                console.log("click tv");
                $(this).parent().parent().remove();
            });

            $('.tv-select-demo-container input[type="radio"]').on('change', function () {
                var rid = $(this).attr('id');
                rid = rid.split("_");
                rid = rid[rid.length - 1];
                if (!isNaN(parseInt(rid))) {
                    var demo_type = $(this).val();
                    console.log(demo_type);
                    var select = $("#nielsen_tv_demo_ids_" + rid);
                    select.html('');
                    select.attr('disabled', null);

                    if (demo_type === 'hh') {
                        select.append('<option value="hh" selected>-</option>');
                        $(this).closest('.tv-select-demo-container').find('.demo_name_' + rid)
                            .val('hh');
                        select.attr('readonly', 'readonly');
                    } else if (demo_type === '') {
                        select.append('<option value="" selected>-</option>');
                        select.attr('disabled', 'disabled');
                    } else if (demo_type === 'p') {
                        tv_demos.each(function (item) {
                            var ids = "";
                            var string = "";
                            $.each(item['blocks']['p'], function (index, value) {
                                ids += value.toString() + ',';
                            });
                            if (item['end'] === null) {
                                string = item['start'] + "+";
                            } else {
                                string = item['start'] + "-" + item['end'];
                            }

                            select.append('<option value="' + ids + '">' + string + '</option>');
                        });
                    } else if (demo_type === 'f') {
                        tv_demos.each(function (item) {
                            var ids = "";
                            var string = "";
                            $.each(item['blocks']['f'], function (index, value) {
                                ids += value.toString() + ',';
                            });
                            if (item['end'] === null) {
                                string = item['start'] + "+";
                            } else {
                                string = item['start'] + "-" + item['end'];
                            }

                            select.append('<option value="' + ids + '">' + string + '</option>');
                        });
                    } else {
                        tv_demos.each(function (item) {
                            if ((item['start'] !== 6) && (item['start'] !== 2)) {
                                var ids = "";
                                var string = "";
                                $.each(item['blocks']['m'], function (index, value) {
                                    ids += value.toString() + ',';
                                });
                                if (item['end'] === null) {
                                    string = item['start'] + "+";
                                } else {
                                    string = item['start'] + "-" + item['end'];
                                }

                                select.append('<option value="' + ids + '">' + string + '</option>');
                            }
                        });
                    }
                }//);
                $('#nielsen_tv_demo_ids').select2({
                    placeholder: "...",
                    minimumResultsForSearch: 10
                }).bind('select2:select', function () {
                    console.log($(this).closest('.tv-select-demo-container').find('.demo_name'));
                    $(this).closest('.tv-select-demo-container').find('.demo_name').val($(this).find('option[value="' + $(this).val() + '"]').html());
                });
                if (typeof nielsen_tv_existing_demo !== 'undefined' && nielsen_tv_existing_demo !== null) {
                    if ((nielsen_tv_existing_demo !== false) && (nielsen_tv_existing_demo !== null)) {
                        container = $('#nielsen_tv_demographics');
                        console.log(nielsen_tv_existing_demo);
                    }
                    $('#nielsen_tv_demo_ids_' + rid).select2({
                        placeholder: "...",
                        minimumResultsForSearch: 10
                    }).bind('select2:select', function () {
                        console.log($(this).closest('.tv-select-demo-container').find('.demo_name_' + rid));
                        $(this).closest('.tv-select-demo-container').find('.demo_name_' + rid).val($(this).find('option[value="' + $(this).val() + '"]').html());
                    });
                    $(".select2-selection.select2-selection--multiple:not(:has(i.fa.fa-search.search-icon-input))").prepend("<i class='fa fa-search search-icon-input'></i>")
                }
            });

            $('#comscore_tv_demo_ids_' + parents).select2({
                placeholder: "...",
                minimumResultsForSearch: 10
            }).bind('select2:select', function () {
                console.log("<<<<");
                console.log(this);
                $(this).parent().find('.demo_comscore_name_' + parents)
                    .val($(this).find('option[value="' + $(this).val() + '"]').html());
            });
            $(".select2-selection.select2-selection--multiple:not(:has(i.fa.fa-search.search-icon-input))").prepend("<i class='fa fa-search search-icon-input'></i>")
            comscore_options_html('#comscore_tv_demo_ids_' + parents)
            $('input[type=radio][name=comscore_tv_demo_type_' + parents + ']').change(function () {
                comscore_options_html('#comscore_tv_demo_ids_' + parents)
                // var demo= $('input:radio[name=comscore_tv_demo_type]:checked').val();
                // var html='';
                // $('#comscore_tv_demo_ids').html(html);
                // $("input[name=comscore_tv_demo_name]").val("");
                // $.each(demo_all, function (index, value) {
                //     if(value[12].indexOf('Age Range') !== -1){
                //         if(demo== 'p') {
                //             if (value[2].indexOf('A') !== -1) {
                //                 var ts= value[2].replace('A', "P ");
                //                 html += '<option value="' + value[0] + '">' + ts + '</option>';
                //                 $("input[name=comscore_tv_demo_name]").val(ts);
                //             }
                //         }
                //         if(demo== 'm') {
                //             if (value[2].indexOf('M') !== -1) {
                //                 var ts= value[2].replace('M', "M ");
                //                 html += '<option value="' + value[0] + '">' + ts + '</option>';
                //                 $("input[name=comscore_tv_demo_name]").val(ts);
                //             }
                //         }
                //         if(demo== 'f') {
                //             if (value[2].indexOf('W') !== -1) {
                //                 var ts= value[2].replace('W', "F ");
                //                 html += '<option value="' + value[0] + '">' + ts + '</option>';
                //                 $("input[name=comscore_tv_demo_name]").val(ts);
                //             }
                //         }
                //     }
                //     if(value[12].indexOf('Household Composition') !== -1){
                //         if(demo == 'hh') {
                //             html += '<option value="' + value[0] + '">' + value[2] + '</option>';
                //             $("input[name=comscore_tv_demo_name]").val(value[2]);
                //         }
                //     }
                // });
                // $('#comscore_tv_demo_ids').html(html);
            });
        });

        $(".del_camp_demo_tv").on('click', function () {
            console.log("click tv");
            $(this).parent().parent().remove();
        });


        $("#add_camp_demo_radio").on("click", function () {
            var container = $(".radio-select-demo-container");
            var parents = container.children().length;
            console.log(container.children());
            console.log(parents);
            container.append('' +
                '<div class="row">\n' +
                '                            <div class="col-md-4">\n' +
                '                                <div class="radio radio-primary">\n' +
                '                                    <input type="radio" name="nielsen_radio_demo_type_' + parents + '"\n' +
                '                                           id="nielsen_radio_demo_type_p_' + parents + '" value="p"\n' +
                '                                           checked>\n' +
                '                                    <label for="nielsen_radio_demo_type_p_' + parents + '">\n' +
                '                                        &nbsp;P</label>\n' +
                '                                </div>\n' +
                '                                <div class="radio radio-primary">\n' +
                '                                    <input type="radio" name="nielsen_radio_demo_type_' + parents + '"\n' +
                '                                           id="nielsen_radio_demo_type_m_' + parents + '" value="m">\n' +
                '                                    <label for="nielsen_radio_demo_type_m_' + parents + '">\n' +
                '                                        &nbsp;M</label>\n' +
                '                                </div>\n' +
                '                                <div class="radio radio-primary">\n' +
                '                                    <input type="radio" name="nielsen_radio_demo_type_' + parents + '"\n' +
                '                                           id="nielsen_radio_demo_type_f_' + parents + '" value="f">\n' +
                '                                    <label for="nielsen_radio_demo_type_f_' + parents + '">\n' +
                '                                        &nbsp;F</label>\n' +
                '                                </div>\n' +
                '                            </div>\n' +
                '                            <div class="col-md-3">\n' +
                '                                <select class="form-control full-width"\n' +
                '                                        name="nielsen_radio_demo_ids_' + parents + '"\n' +
                '                                        id="nielsen_radio_demo_ids_' + parents + '">\n' +
                '                                    <option value="251,264,">6-11</option>\n' +
                '                                    <option value="251,1,264,8,">6-17</option>\n' +
                '                                    <option value="251,1,254,255,264,8,267,268,">\n' +
                '                                        6-24\n' +
                '                                    </option>\n' +
                '                                    <option value="251,1,254,255,3,264,8,267,268,10,">\n' +
                '                                        6-34\n' +
                '                                    </option>\n' +
                '                                    <option value="251,1,254,255,3,4,264,8,267,268,10,11,">\n' +
                '                                        6-44\n' +
                '                                    </option>\n' +
                '                                    <option value="251,1,254,255,3,4,5,264,8,267,268,10,11,12,">\n' +
                '                                        6-49\n' +
                '                                    </option>\n' +
                '                                    <option value="251,1,254,255,3,4,5,6,264,8,267,268,10,11,12,13,">\n' +
                '                                        6-54\n' +
                '                                    </option>\n' +
                '                                    <option value="251,1,254,255,3,4,5,6,82,264,8,267,268,10,11,12,13,14,">\n' +
                '                                        6-64\n' +
                '                                    </option>\n' +
                '                                    <option value="251,1,254,255,3,4,5,6,82,7,264,8,267,268,10,11,12,13,14,15,">\n' +
                '                                        6+\n' +
                '                                    </option>\n' +
                '                                    <option value="1,8,">12-17</option>\n' +
                '                                    <option value="1,254,255,8,267,268,">12-24\n' +
                '                                    </option>\n' +
                '                                    <option value="1,254,255,3,8,267,268,10,">\n' +
                '                                        12-34\n' +
                '                                    </option>\n' +
                '                                    <option value="1,254,255,3,4,8,267,268,10,11,">\n' +
                '                                        12-44\n' +
                '                                    </option>\n' +
                '                                    <option value="1,254,255,3,4,5,8,267,268,10,11,12,">\n' +
                '                                        12-49\n' +
                '                                    </option>\n' +
                '                                    <option value="1,254,255,3,4,5,6,8,267,268,10,11,12,13,">\n' +
                '                                        12-54\n' +
                '                                    </option>\n' +
                '                                    <option value="1,254,255,3,4,5,6,82,8,267,268,10,11,12,13,14,">\n' +
                '                                        12-64\n' +
                '                                    </option>\n' +
                '                                    <option value="1,254,255,3,4,5,6,82,7,8,267,268,10,11,12,13,14,15,">\n' +
                '                                        12+\n' +
                '                                    </option>\n' +
                '                                    <option value="254,255,267,268,">18-24</option>\n' +
                '                                    <option value="254,255,3,267,268,10,">18-34\n' +
                '                                    </option>\n' +
                '                                    <option value="254,255,3,4,267,268,10,11,">\n' +
                '                                        18-44\n' +
                '                                    </option>\n' +
                '                                    <option value="254,255,3,4,5,267,268,10,11,12,">\n' +
                '                                        18-49\n' +
                '                                    </option>\n' +
                '                                    <option value="254,255,3,4,5,6,267,268,10,11,12,13,">\n' +
                '                                        18-54\n' +
                '                                    </option>\n' +
                '                                    <option value="254,255,3,4,5,6,82,267,268,10,11,12,13,14,">\n' +
                '                                        18-64\n' +
                '                                    </option>\n' +
                '                                    <option value="254,255,3,4,5,6,82,7,267,268,10,11,12,13,14,15,">\n' +
                '                                        18+\n' +
                '                                    </option>\n' +
                '                                    <option value="255,3,268,10,">21-34</option>\n' +
                '                                    <option value="255,3,4,268,10,11,">21-44</option>\n' +
                '                                    <option value="255,3,4,5,268,10,11,12,">21-49</option>\n' +
                '                                    <option value="255,3,4,5,6,268,10,11,12,13,">21-54\n' +
                '                                    </option>\n' +
                '                                    <option value="255,3,4,5,6,82,7,268,10,11,12,13,14,15,">\n' +
                '                                        21+\n' +
                '                                    </option>\n' +
                '                                    <option value="3,10,">25-34</option>\n' +
                '                                    <option value="3,4,10,11,">25-44</option>\n' +
                '                                    <option value="3,4,5,10,11,12,">25-49</option>\n' +
                '                                    <option value="3,4,5,6,10,11,12,13," selected>25-54\n' +
                '                                    </option>\n' +
                '                                    <option value="3,4,5,6,82,10,11,12,13,14,">\n' +
                '                                        25-64\n' +
                '                                    </option>\n' +
                '                                    <option value="3,4,5,6,82,7,10,11,12,13,14,15,">\n' +
                '                                        25+\n' +
                '                                    </option>\n' +
                '                                    <option value="4,11,">35-44</option>\n' +
                '                                    <option value="4,5,11,12,">35-49</option>\n' +
                '                                    <option value="4,5,6,11,12,13,">35-54</option>\n' +
                '                                    <option value="4,5,6,82,11,12,13,14,">35-64\n' +
                '                                    </option>\n' +
                '                                    <option value="4,5,6,82,7,11,12,13,14,15,">35+\n' +
                '                                    </option>\n' +
                '                                    <option value="5,12,">45-49</option>\n' +
                '                                    <option value="5,6,12,13,">45-54</option>\n' +
                '                                    <option value="5,6,82,12,13,14,">45-64</option>\n' +
                '                                    <option value="5,6,82,7,12,13,14,15,">45+\n' +
                '                                    </option>\n' +
                '                                    <option value="6,13,">50-54</option>\n' +
                '                                    <option value="6,82,13,14,">50-64</option>\n' +
                '                                    <option value="6,82,7,13,14,15,">50+</option>\n' +
                '                                    <option value="82,14,">55-64</option>\n' +
                '                                    <option value="82,7,14,15,">55+</option>\n' +
                '                                    <option value="7,15,">65+</option>\n' +
                '                                </select>\n' +
                '                                <input name="nielsen_radio_demo_name_' + parents + '" value="25-54" class="demo_name_' + parents + '"\n' +
                '                                       type="hidden"/>\n' +
                '                            </div>\n' +
                '<div class="col-md-3">\n' +
                '                                <button style="border-color: red; color: red" type="button" class="btn btn-error btn-outline del_camp_demo_radio" > <i class="fa fa-trash"></i> Remove</button>\n' +
                '                            </div>' +
                '                        </div>' +
                '');

            $(".del_camp_demo_radio").on('click', function () {
                console.log("click radio");
                $(this).parent().parent().remove();
            });

            $('.radio-select-demo-container input[type="radio"]').on('change', function () {
                var rid = $(this).attr('id');
                rid = rid.split("_");
                rid = rid[rid.length - 1];
                if (!isNaN(parseInt(rid))) {
                    var demo_type = $(this).val();
                    var select = $("#nielsen_radio_demo_ids_" + rid);
                    select.html('');
                    select.attr('disabled', null);

                    if (demo_type === '') {
                        select.append('<option value="" selected>-</option>');
                        select.attr('disabled', 'disabled');
                    } else if (demo_type === 'p') {
                        radio_demos.each(function (item) {
                            var ids = "";
                            var string = "";
                            $.each(item['blocks']['p'], function (index, value) {
                                ids += value.toString() + ',';
                            });
                            if (item['end'] === null) {
                                string = item['start'] + "+";
                            } else {
                                string = item['start'] + "-" + item['end'];
                            }

                            select.append('<option value="' + ids + '">' + string + '</option>');
                        });
                    } else {
                        radio_demos.each(function (item) {
                            var ids = "";
                            var string = "";
                            $.each(item['blocks'][demo_type], function (index, value) {
                                ids += value.toString() + ',';
                            });
                            if (item['end'] === null) {
                                string = item['start'] + "+";
                            } else {
                                string = item['start'] + "-" + item['end'];
                            }

                            select.append('<option value="' + ids + '">' + string + '</option>');
                        });
                    }

                    $('#nielsen_radio_demo_ids_' + rid).select2({
                        placeholder: "...",
                        minimumResultsForSearch: 10
                    }).bind('select2:select', function () {
                        console.log("<<<<");
                        console.log(this);
                        $(this).closest('.radio-select-demo-container').find('.demo_name_' + rid)
                            .val($(this).find('option[value="' + $(this).val() + '"]').html());
                    });
                    $(".select2-selection.select2-selection--multiple:not(:has(i.fa.fa-search.search-icon-input))").prepend("<i class='fa fa-search search-icon-input'></i>")
                }
            });

            $('#nielsen_radio_demo_ids_' + parents).select2({
                placeholder: "...",
                minimumResultsForSearch: 10
            }).bind('select2:select', function () {
                console.log("<<<<");
                console.log(this);
                $(this).closest('.radio-select-demo-container').find('.demo_name_' + parents)
                    .val($(this).find('option[value="' + $(this).val() + '"]').html());
            });
            // if(typeof nielsen_tv_existing_demo !== 'undefined' && nielsen_tv_existing_demo !== null){
            //     if((nielsen_tv_existing_demo !== false) && (nielsen_tv_existing_demo !== null)){
            //         container = $('#nielsen_tv_demographics');
            //         console.log(nielsen_tv_existing_demo);
            $(".select2-selection.select2-selection--multiple:not(:has(i.fa.fa-search.search-icon-input))").prepend("<i class='fa fa-search search-icon-input'></i>")
        });

        $(".del_camp_demo_radio").on('click', function () {
            console.log("click radio");
            $(this).parent().parent().remove();
        });

        $(".second_camp_demos_radio").each(function () {
            var id = $(this).attr("id");
            id = id.split("_");
            id = id[id.length - 1];
            $(this).select2({
                placeholder: "...",
                minimumResultsForSearch: 10
            }).bind('select2:select', function () {
                console.log("<<<<");
                console.log(this);
                $(this).closest('.radio-select-demo-container').find('.demo_name_' + id)
                    .val($(this).find('option[value="' + $(this).val() + '"]').html());
            });
            $(".select2-selection.select2-selection--multiple:not(:has(i.fa.fa-search.search-icon-input))").prepend("<i class='fa fa-search search-icon-input'></i>")
        });

        $(".second_camp_demos_tv").each(function () {
            var id = $(this).attr("id");
            id = id.split("_");
            id = id[id.length - 1];
            $(this).select2({
                placeholder: "...",
                minimumResultsForSearch: 10
            }).bind('select2:select', function () {
                console.log("<<<<");
                console.log(this);
                $(this).closest('.tv-select-demo-container').find('.demo_name_' + id)
                    .val($(this).find('option[value="' + $(this).val() + '"]').html());
            });
            $(".select2-selection.select2-selection--multiple:not(:has(i.fa.fa-search.search-icon-input))").prepend("<i class='fa fa-search search-icon-input'></i>")
        });

        var update_radio_demo_ids_by_markets = function () {
            var exists = false;
            $.each($("#campaign_markets_msa")[0].selectedOptions, function (index, value) {
                var ppm_match = nielsen_radio.where('slug', value.value).first();
                if (typeof ppm_match !== "undefined" && ppm_match['type'] !== 'PPM') {
                    $('#nielsen_radio_demo_ids option[value*="251,"]').detach();
                    exists = true;
                    return false;
                }
            });
            if (!exists && $('#nielsen_radio_demo_ids option[value*="251,"]').length == 0) {
                var optionsToAdd = [
                    {
                        "id": "251,1,254,255,3,4,5,6,82,7,264,8,267,268,10,11,12,13,14,15,",
                        "text": "6+"
                    },
                    {
                        "id": "251,1,254,255,3,4,5,6,82,264,8,267,268,10,11,12,13,14,",
                        "text": "6-64"
                    },
                    {
                        "id": "251,1,254,255,3,4,5,6,264,8,267,268,10,11,12,13,",
                        "text": "6-54"
                    },
                    {
                        "id": "251,1,254,255,3,4,5,264,8,267,268,10,11,12,",
                        "text": "6-49"
                    },
                    {
                        "id": "251,1,254,255,3,4,264,8,267,268,10,11,",
                        "text": "6-44"
                    },
                    {
                        "id": "251,1,254,255,3,264,8,267,268,10,",
                        "text": "6-34"
                    },
                    {
                        "id": "251,1,254,255,264,8,267,268,",
                        "text": "6-24"
                    },
                    {
                        "id": "251,1,264,8,",
                        "text": "6-17"
                    },
                    {
                        "id": "251,264,",
                        "text": "6-11"
                    }
                ]

                $.each(optionsToAdd, function (index, data) {
                    // Append it to the select
                    $("#nielsen_radio_demo_ids").prepend(new Option(data.text, data.id, false, false)).trigger('change');
                })
            }
        };

        if (typeof nielsen_radio !== 'undefined') {
            if (nielsen_radio !== false) {
                radio_markets = collect(radio_markets);
                $(document).ready(function () {
                    //tv_demos = collect(tv_demos);
                    radio_demos = collect(radio_demos);

                    show_loader();
                    $.ajax({
                        type: "GET",
                        url: '/ratings/radio/markets',
                        dataType: 'json',
                        success: function (data) {
                            nielsen_radio = data;
                            $.each(nielsen_radio, function (index, value) {
                                val = radio_markets.where('code', value['code']).first();
                                nielsen_radio[index]['slug'] = val['slug'];
                            });
                            nielsen_radio = collect(nielsen_radio);

                            if (/*typeof nielsen_radio_existing !== 'undefined'*/typeof actual_markets !== "undefined" && actual_markets.length > 0) {
                                //if(nielsen_radio_existing !== false){
                                var hide_loader_cont = 0
                                $.each(/*nielsen_radio_existing*/actual_markets, function (index, market) {
                                    if (market['type'] === "msa") {
                                        $.ajax({
                                            type: "GET",
                                            url: '/ratings/radio/books/?code=' + market['code'],
                                            dataType: 'json',
                                            //value: value,
                                            success: function (data) {
                                                if (typeof nielsen_radio_markets[market['code']] === 'undefined') {
                                                    nielsen_radio_markets[market['code']] = data;
                                                }

                                                var match = nielsen_radio.where('code', market['code']).first();
                                                if (typeof match !== "undefined") {
                                                    var html = '<div class="form-inline row market-ratings-container" data-market="' + match['code'] + '" data-media="radio"><div class="form-group col-md-3 m-b-10"><div class="col-md-12"><input class="form-control full-width nielsen_radio_market" value=" ' + match['name'] + '" readonly></div><input type="hidden"  name="nielsen_radio_market[]" value="' + match['code'] + '" /><input type="hidden" class="form-control full-width nielsen_radio_market_name" name="nielsen_radio_market_name[]" value="' + match['name'] + '" readonly="" aria-invalid="false">' +
                                                        '</div>' +
                                                        '<div class="form-group col-md-3 m-b-10"><div class="col-md-12">';

                                                    if (match['type'] === 'PPM') {
                                                        html += '<select class="form-control full-width nielsen_tv_playback_type" name="nielsen_radio_geography[]"><option value="Metro" selected>MSA</option>';
                                                    } else {
                                                        html += '<select class="form-control full-width nielsen_tv_playback_type" name="nielsen_radio_geography[]"> <option value="Metro" selected>MSA</option><option value="TSA">TSA</option><option value="DMA">DMA</option>';
                                                    }


                                                    html += '</select></div></div><div class="form-group col-md-6 m-b-10"><div class="col-md-12"><select class="form-control full-width" data-market="' + match['code'] + '" id="nielsen_radio_books" multiple name="nielsen_radio_books_' + match['code'] + '[]">';
                                                    var names = '';
                                                    var index_exist = nielsen_radio_existing.findIndex(elem => market["code"] === elem.msa)
                                                    if (index_exist !== -1) {
                                                        selected = nielsen_radio_existing[index_exist]['books'].split(',');
                                                        $.each(selected, function (index, value) {
                                                            if (value !== "")
                                                                selected[index] = parseInt(value);
                                                        });
                                                        console.log(selected);
                                                    }
                                                    data = Object.values(data)
                                                    data.sort(function (a, b) {
                                                        var keyA = new Date(a.start)
                                                        var keyB = new Date(b.start);
                                                        if (keyA > keyB) return -1;
                                                        if (keyA < keyB) return 1;
                                                        return 0;
                                                    });
                                                    $.each(data, function (index, value) {
                                                        html += '<option value="' + value['id'] + '">' + value['name'] + '</option>';
                                                        if (index_exist !== -1)
                                                            if (selected.indexOf(value['id']) !== -1)
                                                                names += value['name'];
                                                        if (index < data.length - 1)
                                                            names += ','
                                                    });
                                                    html += '</select>';
                                                    if (index_exist !== -1)
                                                        html += '<input type="hidden" class="books_names_field" name="nielsen_radio_books_name_' + match['code'] + '[]" value="' + names + '">';
                                                    else
                                                        html += '<input type="hidden" class="books_names_field" name="nielsen_radio_books_name_' + match['code'] + '[]">';
                                                    html += '</div></div></div>';
                                                    var container = $('#nielsen_radio_books').find('.books_container');

                                                    container.append(html);
                                                    if (index_exist !== -1)
                                                        $.each(selected, function (index, value) {
                                                            if (value !== "") {
                                                                container.find('#nielsen_radio_books option[value="' + value + '"]').prop('selected', 'selected');
                                                            }
                                                        });

                                                    container.find('select[name="nielsen_radio_books_' + match['code'] + '[]"]').select2({
                                                        placeholder: "Select at least one and a maximum of: " + match['frequency'],
                                                        closeOnSelect: false,
                                                        minimumResultsForSearch: 10,
                                                        maximumSelectionLength: match['frequency']
                                                    }).on('change.select2', function (index) {
                                                        var select_name = $(this).attr('name');
                                                        console.log("name: " + select_name);
                                                        var container = $(this).closest('.row .market-ratings-container');
                                                        var names = [];
                                                        $.each($(this).val(), function (index, value) {
                                                            names.push($(container).find('select[name="' + select_name + '"] option[value="' + value + '"]').html());
                                                        });
                                                        container.find('.books_names_field').val(names.join());
                                                    }).on('select2:select', function (event) {
                                                        if(event.params.data.text == 'MARCH 2020' && match['type'] === 'PPM'){
                                                            swal({
                                                                    title: "Notification",
                                                                    text: "Given the anomalous nature of audience behavior during the COVID-19 Public Health Emergency, it is Nielsen's position that future buying and planning decisions for periods that fall outside the COVID-19 crisis should not be made using COVID-19 impacted audience estimates.",
                                                                    type: "warning",
                                                                    showCancelButton: false,
                                                                    confirmButtonClass: "btn-danger",
                                                                    confirmButtonText: "OK",
                                                                    //cancelButtonText: "",
                                                                    closeOnConfirm: true,
                                                                    closeOnCancel: true
                                                                },
                                                                function (isConfirm) {
                                                                    if(isConfirm){

                                                                    }
                                                                });
                                                        }

                                                    }).on('select2:selecting', function (event) {
                                                        var content = $(this).html();
                                                        console.log('----');
                                                        console.log(content);
                                                        console.log(content.indexOf("Small"));
                                                        console.log($(this).val().length);

                                                        if(typeof event.params.args !== 'undefined')
                                                            var form_curr_books = $(event.currentTarget).val().concat([event.params.args.data.id]);
                                                        else
                                                            var form_curr_books = $(event.currentTarget).val();
                                                        var selected = [];
                                                        $('#form_books option').each(function(){
                                                            if(form_curr_books.indexOf($(this).val()) !== -1){
                                                                selected.push($(this).text());
                                                            }
                                                        });
                                                        console.log('form_curr_books: ', form_curr_books);
                                                        console.log('event: ', event);

                                                        if ($(this).val().length == 1 && content.indexOf("Small") !== -1) {
                                                            event.preventDefault();
                                                            event.stopPropagation();
                                                            global_notification('warning', "You cannot select this survey together with your current survey.\n\n You can only select one condensed market two-book average survey alone since these surveys already include an average of two consecutive surveys.");
                                                            return false;
                                                        }
                                                    });
                                                    $(".select2-selection.select2-selection--multiple:not(:has(i.fa.fa-search.search-icon-input))").prepend("<i class='fa fa-search search-icon-input'></i>")

                                                    //$('#nielsen_radio_books').removeClass('hidden').addClass('shown');
                                                }
                                                hide_loader_cont++
                                                if (actual_markets.length === hide_loader_cont)
                                                    hide_loader()
                                            },
                                            error: function (xhr) {
                                                ajax_error();
                                                hide_loader();
                                            }
                                        });
                                    } else {
                                        hide_loader_cont++
                                        if (actual_markets.length === hide_loader_cont)
                                            hide_loader()
                                    }
                                });
                                //}
                            }

                            if (typeof nielsen_radio_existing_demo !== 'undefined') {
                                if ((nielsen_radio_existing_demo !== false) && (nielsen_radio_existing_demo !== null)) {
                                    container = $('#nielsen_radio_demographics');
                                    console.log(nielsen_radio_existing_demo);
                                    container.find('input[name="nielsen_radio_demo_type"][value="' + nielsen_radio_existing_demo['demo_type'] + '"]').prop("checked", true).trigger('change');
                                    container.find('select[name="nielsen_radio_demo_ids"] option[value="' + nielsen_radio_existing_demo['demo_ids'] + '"]').prop('selected', 'selected').trigger('change.select2');
                                    $('.radio-select-demo-container').find('.demo_name').val(nielsen_radio_existing_demo['demo_name']);
                                    console.log("rdemo1");
                                    console.log(nielsen_radio_existing_demo['demo_name']);
                                    console.log($('.radio-select-demo-container').find('.demo_name'));
                                }
                            }

                            if (typeof nielsen_radio_existing_sec_demo !== 'undefined') {
                                if ((nielsen_radio_existing_sec_demo !== false) && (nielsen_radio_existing_sec_demo !== null)) {
                                    for (var i = 1; i < nielsen_radio_existing_sec_demo.length; i++) {
                                        var aux_demo = nielsen_radio_existing_sec_demo[i];
                                        container = $('#nielsen_radio_demographics');
                                        console.log(aux_demo);
                                        container.find('input[name="nielsen_radio_demo_type_' + i + '"][value="' + aux_demo['demo_type'] + '"]').prop("checked", true).trigger('change');
                                        container.find('select[name="nielsen_radio_demo_ids_' + i + '"] option[value="' + aux_demo['demo_ids'] + '"]').prop('selected', 'selected').trigger('change.select2');
                                        $('.radio-select-demo-container').find('.demo_name_' + i).val(aux_demo['demo_name']);
                                    }
                                }
                            }

                            update_radio_demo_ids_by_markets();

                            if (typeof actual_markets === "undefined" || actual_markets.length <= 0)
                                hide_loader();
                        },
                        error: function (xhr) {
                            ajax_error();
                            hide_loader();
                        }
                    });
                });

                var nielsen_radio_markets = {};

                $('.radio-select-demo-container input[type="radio"]').on('change', function () {
                    var rid = $(this).attr('id');
                    rid = rid.split("_");
                    rid = rid[rid.length - 1];
                    if (isNaN(parseInt(rid))) {
                        var demo_type = $(this).val();
                        var select = $($(this).closest('.radio-select-demo-container').find('select')[0]);
                        select.html('');
                        select.attr('disabled', null);

                        if (demo_type === '') {
                            select.append('<option value="" selected>-</option>');
                            select.attr('disabled', 'disabled');
                        } else if (demo_type === 'p') {
                            console.log(radio_demos);
                            radio_demos.each(function (item) {
                                var ids = "";
                                var string = "";
                                $.each(item['blocks']['p'], function (index, value) {
                                    ids += value.toString() + ',';
                                });
                                if (item['end'] === null) {
                                    string = item['start'] + "+";
                                } else {
                                    string = item['start'] + "-" + item['end'];
                                }

                                select.append('<option value="' + ids + '">' + string + '</option>');
                            });
                        } else {
                            radio_demos.each(function (item) {
                                var ids = "";
                                var string = "";
                                $.each(item['blocks'][demo_type], function (index, value) {
                                    ids += value.toString() + ',';
                                });
                                if (item['end'] === null) {
                                    string = item['start'] + "+";
                                } else {
                                    string = item['start'] + "-" + item['end'];
                                }

                                select.append('<option value="' + ids + '">' + string + '</option>');
                            });
                        }
                    }
                });

                $('#nielsen_radio_demo_ids').select2({
                    placeholder: "...",
                    minimumResultsForSearch: 10
                }).bind('select2:select', function () {
                    console.log("<<<<");
                    console.log(this);
                    $(this).closest('.radio-select-demo-container').find('.demo_name')
                        .val($(this).find('option[value="' + $(this).val() + '"]').html());
                });
                $(".select2-selection.select2-selection--multiple:not(:has(i.fa.fa-search.search-icon-input))").prepend("<i class='fa fa-search search-icon-input'></i>")
            } else {
                var radio_demos = collect(radio_demos);
                console.log('^^^^^^^^^^^^^^^^^^^^^^^^^^^^ radio demos');
                console.log(radio_demos);
                $('.radio-select-demo-container input[type="radio"]').on('change', function () {
                    var rid = $(this).attr('id');
                    rid = rid.split("_");
                    rid = rid[rid.length - 1];
                    if (isNaN(parseInt(rid))) {
                        var demo_type = $(this).val();
                        var select = $($(this).closest('.radio-select-demo-container').find('select')[0]);
                        select.html('');
                        select.attr('disabled', null);

                        if (demo_type === '') {
                            select.append('<option value="" selected>-</option>');
                            select.attr('disabled', 'disabled');
                        } else if (demo_type === 'p') {
                            radio_demos.each(function (item) {
                                var ids = "";
                                var string = "";
                                $.each(item['blocks']['p'], function (index, value) {
                                    ids += value.toString() + ',';
                                });
                                if (item['end'] === null) {
                                    string = item['start'] + "+";
                                } else {
                                    string = item['start'] + "-" + item['end'];
                                }

                                select.append('<option value="' + ids + '">' + string + '</option>');
                            });
                        } else {
                            radio_demos.each(function (item) {
                                var ids = "";
                                var string = "";
                                $.each(item['blocks'][demo_type], function (index, value) {
                                    ids += value.toString() + ',';
                                });
                                if (item['end'] === null) {
                                    string = item['start'] + "+";
                                } else {
                                    string = item['start'] + "-" + item['end'];
                                }

                                select.append('<option value="' + ids + '">' + string + '</option>');
                            });
                        }
                    }
                });

                $('#nielsen_radio_demo_ids').select2({
                    placeholder: "...",
                    minimumResultsForSearch: 10
                }).bind('select2:select', function () {
                    console.log("<<<<");
                    console.log(this);
                    $(this).closest('.radio-select-demo-container').find('.demo_name')
                        .val($(this).find('option[value="' + $(this).val() + '"]').html());
                });
                $(".select2-selection.select2-selection--multiple:not(:has(i.fa.fa-search.search-icon-input))").prepend("<i class='fa fa-search search-icon-input'></i>")

                if (typeof nielsen_radio_existing_demo !== 'undefined') {
                    if ((nielsen_radio_existing_demo !== false) && (nielsen_radio_existing_demo !== null)) {
                        container = $('#nielsen_radio_demographics');
                        console.log(nielsen_radio_existing_demo);
                        container.find('input[name="nielsen_radio_demo_type"][value="' + nielsen_radio_existing_demo['demo_type'] + '"]').prop("checked", true).trigger('change');
                        container.find('select[name="nielsen_radio_demo_ids"] option[value="' + nielsen_radio_existing_demo['demo_ids'] + '"]').prop('selected', 'selected').trigger('change.select2');
                        $('.radio-select-demo-container').find('.demo_name').val(nielsen_radio_existing_demo['demo_name']);
                        console.log("rdemo2");
                        console.log(nielsen_radio_existing_demo['demo_name']);
                        console.log($('.radio-select-demo-container').find('.demo_name'));
                    }
                }
                if (typeof nielsen_radio_existing_sec_demo !== 'undefined') {
                    if ((nielsen_radio_existing_sec_demo !== false) && (nielsen_radio_existing_sec_demo !== null)) {
                        for (var i = 1; i < nielsen_radio_existing_sec_demo.length; i++) {
                            var aux_demo = nielsen_radio_existing_sec_demo[i];
                            container = $('#nielsen_radio_demographics');
                            console.log(aux_demo);
                            container.find('input[name="nielsen_radio_demo_type_' + i + '"][value="' + aux_demo['demo_type'] + '"]').prop("checked", true).trigger('change');
                            container.find('select[name="nielsen_radio_demo_ids_' + i + '"] option[value="' + aux_demo['demo_ids'] + '"]').prop('selected', 'selected').trigger('change.select2');
                            $('.radio-select-demo-container').find('.demo_name_' + i).val(aux_demo['demo_name']);
                        }
                    }
                }
            }
        } else {
            var radio_demos = collect(radio_demos);
            $('.radio-select-demo-container input[type="radio"]').on('change', function () {
                var rid = $(this).attr('id');
                rid = rid.split("_");
                rid = rid[rid.length - 1];
                if (isNaN(parseInt(rid))) {
                    var demo_type = $(this).val();
                    var select = $($(this).closest('.radio-select-demo-container').find('select')[0]);
                    select.html('');
                    select.attr('disabled', null);

                    if (demo_type === '') {
                        select.append('<option value="" selected>-</option>');
                        select.attr('disabled', 'disabled');
                    } else if (demo_type === 'p') {
                        radio_demos.each(function (item) {
                            var ids = "";
                            var string = "";
                            $.each(item['blocks']['p'], function (index, value) {
                                ids += value.toString() + ',';
                            });
                            if (item['end'] === null) {
                                string = item['start'] + "+";
                            } else {
                                string = item['start'] + "-" + item['end'];
                            }

                            select.append('<option value="' + ids + '">' + string + '</option>');
                        });
                    } else {
                        radio_demos.each(function (item) {
                            var ids = "";
                            var string = "";
                            $.each(item['blocks'][demo_type], function (index, value) {
                                ids += value.toString() + ',';
                            });
                            if (item['end'] === null) {
                                string = item['start'] + "+";
                            } else {
                                string = item['start'] + "-" + item['end'];
                            }

                            select.append('<option value="' + ids + '">' + string + '</option>');
                        });
                    }
                }
            });

            $('#nielsen_radio_demo_ids').select2({
                placeholder: "...",
                minimumResultsForSearch: 10
            }).bind('select2:select', function () {
                console.log("<<<<");
                console.log(this);
                $(this).closest('.radio-select-demo-container').find('.demo_name')
                    .val($(this).find('option[value="' + $(this).val() + '"]').html());
            });
            $(".select2-selection.select2-selection--multiple:not(:has(i.fa.fa-search.search-icon-input))").prepend("<i class='fa fa-search search-icon-input'></i>")

            if (typeof nielsen_radio_existing_demo !== 'undefined') {
                if ((nielsen_radio_existing_demo !== false) && (nielsen_radio_existing_demo !== null)) {
                    container = $('#nielsen_radio_demographics');
                    console.log(nielsen_radio_existing_demo);
                    container.find('input[name="nielsen_radio_demo_type"][value="' + nielsen_radio_existing_demo['demo_type'] + '"]').prop("checked", true).trigger('change');
                    container.find('select[name="nielsen_radio_demo_ids"] option[value="' + nielsen_radio_existing_demo['demo_ids'] + '"]').prop('selected', 'selected').trigger('change.select2');
                    $('.radio-select-demo-container').find('.demo_name').val(nielsen_radio_existing_demo['demo_name']);
                    console.log("rdemo3");
                    console.log(nielsen_radio_existing_demo['demo_name']);
                    console.log($('.radio-select-demo-container').find('.demo_name'));
                }
            }
            if (typeof nielsen_radio_existing_sec_demo !== 'undefined') {
                if ((nielsen_radio_existing_sec_demo !== false) && (nielsen_radio_existing_sec_demo !== null)) {
                    for (var i = 1; i < nielsen_radio_existing_sec_demo.length; i++) {
                        var aux_demo = nielsen_radio_existing_sec_demo[i];
                        container = $('#nielsen_radio_demographics');
                        console.log(aux_demo);
                        container.find('input[name="nielsen_radio_demo_type_' + i + '"][value="' + aux_demo['demo_type'] + '"]').prop("checked", true).trigger('change');
                        container.find('select[name="nielsen_radio_demo_ids_' + i + '"] option[value="' + aux_demo['demo_ids'] + '"]').prop('selected', 'selected').trigger('change.select2');
                        $('.radio-select-demo-container').find('.demo_name_' + i).val(aux_demo['demo_name']);
                    }
                }
            }
        }
        /**
         * Market Searchable Multiselect
         */
        $('.wizard-finish-campaign').on('click', function (event) {

            var keepgoing = false;
            var result = true;
            var con = 0;
            $("select").each(function () {
                console.log($(this)[0]);
                var name = $(this)[0].name;
                if (!keepgoing && name.indexOf("nielsen_radio_books") !== -1 || name.indexOf("nielsen_tv_playback_type") !== -1 || name.indexOf("nielsen_tv_share") !== -1 || name.indexOf("nielsen_tv_hut") !== -1 || name.indexOf("comscore_tv_playback_type") !== -1 || name.indexOf("avails_view_year") !== -1 || name.indexOf("comscore_interval") !== -1 || name.indexOf("avails_view_quarter") !== -1) { //
                    var t = $(this).find(":selected").length;
                    var val = "";
                    if (t === 1)
                        val = $(this).find(":selected")[0].value;
                    console.log("select: " + t);
                    if ((t === 0 || (t === 1 && val === "")) && con === 0) {
                        con++;
                        //var user_selection = confirm("You have not selected surveys for markets with available ratings do you want to continue in manual ratings mode?");
                        var user_selection = true;
                        keepgoing = true;
                        if (!user_selection) {
                            result = false;
                            return false;
                        }
                    }
                }
            });

            var dma = ('#campaign_markets');
            var msa = ('#campaign_markets_msa');
            var custom = ('#campaign_markets_custom');

            console.log('YES3');
            if (typeof dma !== 'undefined' && typeof msa !== 'undefined' && typeof custom !== 'undefined') {
                if ($(dma).val().length == 0 && $(msa).val().length == 0 && $(custom).val().length == 0) {
                    event.stopPropagation();
                    global_notification('warning', 'Should select at least one Market');
                    result = false;
                }
            }
            if (result) {
                if($("#app-campaigns-form-planner").length)
                     $("#app-campaigns-form-planner").submit();
                else
                    $("#app-campaigns-form-planner-monthly").submit();
            }
        });

        $('#camp-previous').on('click', function () {
            if ($("#app-campaigns-form-wizard-planner .custom-tabs .tab-current").attr("id") == 2) {
                $('.wizard-previous').css('display', 'block');
                $('.wizard-next').css('display', 'block');
                $('.wizard-finish-campaign').css('display', 'none');
            } else if ($('#app-campaigns-form-planner').length) {
                if($("#app-campaigns-form-planner").valid()) {
                    $('.wizard-finish-campaign').css('display', 'none');
                    $('.wizard-next').css('display', 'block');
                    $('.wizard-previous').css('display', 'none');
                }
            }
            else if ($('#app-campaigns-form-planner-monthly').length) {
                if($("#app-campaigns-form-planner-monthly").valid()) {
                    $('.wizard-finish-campaign').css('display', 'none');
                    $('.wizard-next').css('display', 'block');
                    $('.wizard-previous').css('display', 'none');
                }
            }

        });
        $('#camp-next').on('click', function () {
            if ($("#app-campaigns-form-wizard-planner .custom-tabs .tab-current").attr("id") == 0) {
                $('.wizard-previous').css('display', 'block');
            } else if($('#app-campaigns-form-planner').length){
                if ($('#app-campaigns-form-planner').valid()) {
                    $('.wizard-finish-campaign').css('display', 'block');
                    $('.wizard-next').css('display', 'none');
                    $('.wizard-previous').css('display', 'block');
                }
            }
            else if($('#app-campaigns-form-planner-monthly').length){
                if ($('#app-campaigns-form-planner-monthly').valid()) {
                    $('.wizard-finish-campaign').css('display', 'block');
                    $('.wizard-next').css('display', 'none');
                    $('.wizard-previous').css('display', 'block');
                }
            }
        });
        $('#add_brand').on('click', function (e) {
            $('#addBrandModal').modal('show');
        });

        $('#add_product').on('click', function (e) {
            $('#addProductModal').modal('show');
        });

        $('#confirm_create_brand').on('click', function (e) {
            var adv_id_new_brand = $('#adv_id_new_brand').val();
            var brand_name_new = $('#brand_name_new').val();
            var html = $('#campaign_brand').html();

            if (brand_name_new == '')
                global_notification('warning', 'Brand name is required...');
            else {
                $.ajax({
                    type: 'GET',
                    url: '/campaign/add_new/brand/' + brand_name_new + '/' + adv_id_new_brand,
                    dataType: 'json',
                    encode: true,
                    success: function (data) {
                        var select = $('#campaign_brand');
                        select.html('');
                        html += '<option value="' + data['brand']['slug'] + '" data-product-url="' + data['route'] + '" selected>' + data['brand']['name'] + ' </option>';
                        select.html(html);
                        select.find('option').prop('selected', null);
                        select.find('option[value="' + data['brand']['slug'] + '"]').prop('selected', 'selected');
                        $('#campaign_product').html('');

                        $('#addBrandModal').modal('hide');
                        global_notification('success', 'Brand added...');

                    },
                    error: function (xhr) {
                        debug(xhr.responseText);
                    }
                });
            }
        });
        $('#confirm_create_product').on('click', function (e) {
            var adv_id_new_brand = $('#adv_id_new_product').val();
            var brand_selected = $('#campaign_brand option:selected').val();
            var product_name_new = $('#product_name_new').val();

            var html = $('#campaign_product').html();
            if (brand_selected == 'undefined' || brand_selected == '' || brand_selected == null)
                global_notification('warning', 'Please select a Brand first...');
            else if (product_name_new == '')
                global_notification('warning', 'Product name is required...');
            else {
                $.ajax({
                    type: 'GET',
                    url: '/campaign/add_new/product/' + brand_selected + '/' + adv_id_new_brand + '/' + product_name_new,
                    dataType: 'json',
                    encode: true,
                    success: function (data) {
                        var select = $('#campaign_product');
                        select.html('');
                        html += '<option value="' + data['product']['slug'] + '">' + data['product']['name'] + ' </option>';
                        select.html(html);
                        select.find('option').prop('selected', null);
                        select.find('option[value="' + data['product']['slug'] + '"]').prop('selected', 'selected');
                        select.prop('disabled', false);

                        $('#addProductModal').modal('hide');
                        global_notification('success', 'Product added...');

                    },
                    error: function (xhr) {
                        debug(xhr.responseText);
                    }
                });
            }
        });

        $('#campaign_media_types').on('select2:unselecting', function (e) {
            console.log(e);
            var del = e.params.args.data.id;
            if (typeof saved_markets !== 'undefined')
                var h_order = saved_markets[saved_markets.length - 1];
            else
                var h_order = false;

            if (h_order == 1) {
                var enc = false;
                if (typeof ordered_mtypes !== 'undefined') {
                    if (ordered_mtypes.indexOf(del.toLowerCase()) !== -1)
                        enc = true;

                }
                if (enc) {
                    global_notification('warning', 'This campaign has order(s) created, you can not delete this Media Type');
                    e.stopPropagation();
                    e.preventDefault();
                }
            }
        });

        var stop_e = false;
        var media_values = $('#campaign_media_types').val();

        var marketRatingsMultiSelect = function (id) {

            $(id).multiSelect({
                selectableHeader: "<i class='fa fa-search search-icon-input'></i><input type='text' class='search-input full-width form-control' autocomplete='off' placeholder='Search...'>",
                selectionHeader: "<div style='height: 38px;'><label>Selected</label></div>",
                afterInit: function (ms) {
                    var that = this,
                        $selectableSearch = that.$selectableUl.prev(),
                        selectableSearchString = '#' + that.$container.attr('id') + ' .ms-elem-selectable:not(.ms-selected)';

                    that.qs1 = $selectableSearch.quicksearch(selectableSearchString)
                        .on('keydown', function (e) {
                            if (e.which === 40) {
                                that.$selectableUl.focus();
                                return false;
                            }
                        });
                },
                afterSelect: function (values) {
                    if (typeof saved_markets !== 'undefined')
                        var h_order = saved_markets[saved_markets.length - 1];
                    else {
                        var h_order = false;
                        stop_e = false;
                    }
                    if (!stop_e) {
                        var match;
                        value = values[0];
                        type = value.substring(0, 3);

                        if (type === 'dma' && comscore_tv !== false && comscore_markets.length) {
                            var exists = comscore_markets.find(function (element) {
                                return element.slug === value;
                            });
                            //var exists = comscore_markets.where('slug', value).first();
                            if (typeof exists !== 'undefined' && !$('input[name="comscore_tv_market[]"][value="' + exists["code"] + '"]').length) {
                                var html = '<div class="form-inline row market-ratings-container" data-market="' + exists['code'] + '" data-media="tv"><div class="form-group col-md-3 m-b-10"><div class="col-md-12"><input class="form-control full-width nielsen_tv_market" id="comscore_tv_market" name="comscore_tv_market_name[]" value="' + exists['name'] + '" readonly><input type="hidden" name="comscore_tv_market[]" value="' + exists['code'] + '"/></div></div><div class="form-group col-md-3 m-b-10"><div class="col-md-12"><select class="form-control full-width" id="comscore_tv_playback_type" name="comscore_tv_playback_type[]">' +
                                    '<option value="">Choose One...</option>' +
                                    '<option value="live">Live Only</option>' +
                                    '</select></div></div>';

                                var htmltoadd = ""
                                // var nowTime = (moment(exists.end) < moment()) ? moment(exists.end) : moment().subtract(1, 'months')
                                // var gtrTime = moment(exists.start)//moment().subtract(1, 'months').subtract(2, 'years')
                                //
                                // while(nowTime >= gtrTime){
                                //     htmltoadd += '<option value="' + nowTime.format("MM/YYYY") + '">' + nowTime.format("MM/YYYY") + '</option>';
                                //     nowTime.subtract(1, 'months')
                                // }
                                var container = $('#comscore_dat').find('.comscore_books_container');
                                $.ajax({
                                    type: 'GET',
                                    url: '/campaign/get/comscore/books/allowed/' + exists['code'],
                                    dataType: 'json',
                                    encode: true,
                                    success: function (data) {
                                        console.log('allowed3: ' + data);
                                        data.sort(function (a, b) {               // Detach from select, then Sort
                                            var at = moment(a);
                                            var bt = moment(b);
                                            return (at < bt) ? 1 : ((at > bt) ? -1 : 0);
                                        });
                                        for (var i in data) {
                                            htmltoadd += '<option value="' + moment(data[i]).format("MM/YYYY") + '">' + moment(data[i]).format("MM/YYYY") + '</option>';
                                        }

                                        html += '<div class="form-group col-md-2 m-b-10"><div class="col-md-12">' +
                                            '<select class="form-control full-width" id="comscore_interval" name="comscore_interval[]">' +
                                            '<option value="">Select a Date</option>' + htmltoadd + '</select>' +
                                            '</div></div><div class="form-group col-md-2 m-b-10">' +
                                            '<div class="col-md-12"><select name="avails_view_quarter[]" id="avails_view_quarter" class="form-control full-width">' +
                                            '<option value="">Select a Date</option>' + htmltoadd + '</select>' +
                                            '</div></div></div>';


                                        $(html).find('#comscore_tv_market').val(exists['name']);

                                        container.append(html);
                                        $(container.find('select[name="comscore_interval[]"]')).select2()
                                        $(container.find('select[name="avails_view_quarter[]"]')).select2()
                                    },
                                    error: function (xhr) {
                                        hide_loader();
                                        debug(xhr.responseText);
                                    }
                                });


                                $('select[name="comscore_tv_playback_type[]"]').select2()

                            }
                        }

                        if ((type === 'dma') && ((nielsen_tv !== false)/* || comscore_tv !== false*/)) {
                            marketRatingsMultiSelectVisibility(this.$element, 'tv');
                            // var comscore_match = (typeof comscore_markets !== 'undefined' && comscore_markets !== "" && comscore_markets !== null && comscore_markets.length) ? comscore_markets.find(function(element){return element.slug == value;}) : undefined;
                            match = nielsen_tv.where('slug', value).first();
                            if (typeof match !== 'undefined' /*|| typeof comscore_match !== 'undefined'*/) {
                                if (!$('input[name="nielsen_tv_market[]"][value="' + match["dma"] + '"]').length) {
                                    show_loader();
                                    $.ajax({
                                        type: "GET",
                                        url: '/ratings/tv/local/monthly/allbooks/?dma=' + match['dma'],
                                        dataType: 'json',
                                        success: function (data) {
                                            if (typeof nielsen_tv_markets[match['dma']] === 'undefined') {
                                                nielsen_tv_markets[match['dma']] = data;
                                            }
                                            console.log("books");
                                            //console.log(data);
                                            console.log(collect(data).keyBy('playback_type').all());
                                            var form_playbacks = collect(data).sortBy('name').keyBy('playback_type').all();

                                            var html = '<div class="form-inline row market-ratings-container" data-market="' + match['dma'] + '" data-media="tv"><div class="form-group col-md-3 m-b-10"><div class="col-md-12"><input class="form-control full-width nielsen_tv_market" id="nielsen_tv_market" name="nielsen_tv_market_name[]" value="' + match['name'] + '" readonly><input type="hidden" name="nielsen_tv_market[]" value="' + match['dma'] + '"/></div></div><div class="form-group col-md-3 m-b-10"><div class="col-md-12"><select class="form-control full-width" id="nielsen_tv_playback_type" name="nielsen_tv_playback_type[]"><option value="">Choose One...</option>';
                                            /*$.each(tv_playback_types[match['type']], function (index, value) {
                                    html += '<option value="' + index + '">' + value + '</option>';
                                });*/

                                            $.each(form_playbacks, function (index, value) {
                                                html += '<option value="' + index + '">' + playback_types_all[index] + '</option>';
                                            });

                                            html += '</select></div></div><div class="form-group col-md-3 m-b-10"><div class="col-md-12"><select class="form-control full-width" id="nielsen_tv_share" name="nielsen_tv_share[]" disabled></select><input type="hidden" name="nielsen_tv_share_name[]" /></div></div><div class="form-group col-md-3 m-b-10"><div class="col-md-12"><select class="form-control full-width" id="nielsen_tv_hut" name="nielsen_tv_hut[]" disabled></select><input type="hidden" name="nielsen_tv_hut_name[]" /></div></div></div>';
                                            var container = $('#nielsen_tv_books').find('.books_container');
                                            $(html).find('#nielsen_tv_market').val(match['name']);

                                            container.append(html);

                                            container.find('div.row[data-market="' + match['dma'] + '"] select[name="nielsen_tv_playback_type[]"]').bind('change', function () {
                                                marketMultiSelectNielsenPlaybackChange(this);
                                            });
                                            hide_loader();
                                        },
                                        error: function (xhr) {
                                            ajax_error();
                                            hide_loader();
                                        }
                                    });
                                }
                            } else {
                                swal({
                                        title: "Warning",
                                        text: "The market you are selecting a demo for does not have ratings provided. This will require manual ratings entry.",
                                        type: "warning",
                                        showCancelButton: false,
                                        confirmButtonClass: "btn-danger",
                                        confirmButtonText: "OK",
                                        cancelButtonText: "Close",
                                        closeOnConfirm: true,
                                        closeOnCancel: true
                                    },
                                    function (isConfirm) {

                                    });
                            }
                        } else if ((type === 'msa') && (nielsen_radio !== false)) {
                            marketRatingsMultiSelectVisibility(this.$element, 'radio');

                            var match = nielsen_radio.where('slug', value).first();
                            if (typeof match !== 'undefined') {
                                if (!$('input[name="nielsen_radio_market[]"][value="' + match["code"] + '"]').length) {
                                    show_loader();
                                    $.ajax({
                                        type: "GET",
                                        url: '/ratings/radio/books/?code=' + match['code'],
                                        dataType: 'json',
                                        success: function (data) {
                                            if (typeof nielsen_radio_markets[match['code']] === 'undefined') {
                                                nielsen_radio_markets[match['code']] = data;
                                            }

                                            var html = '<div class="form-inline row market-ratings-container" data-market="' + match['code'] + '" data-media="radio"><div class="form-group col-md-3 m-b-10"><div class="col-md-12"><input class="form-control full-width nielsen_radio_market" name="nielsen_radio_market_name[]" value=" ' + match['name'] + '" readonly></div><input type="hidden"  name="nielsen_radio_market[]" value="' + match['code'] + '" /></div><div class="form-group col-md-3 m-b-10"><div class="col-md-12">';

                                            if (match['type'] === 'PPM') {
                                                html += '<select class="form-control full-width nielsen_tv_playback_type" name="nielsen_radio_geography[]"><option value="Metro" selected>MSA</option>';
                                            } else {
                                                html += '<select class="form-control full-width nielsen_tv_playback_type" name="nielsen_radio_geography[]"> <option value="Metro" selected>MSA</option><option value="TSA">TSA</option><option value="DMA">DMA</option>';
                                            }


                                            html += '</select></div></div><div class="form-group col-md-6 m-b-10"><div class="col-md-12"><select class="form-control full-width" data-market="' + match['code'] + '" id="nielsen_radio_books" multiple name="nielsen_radio_books_' + match['code'] + '[]">';

                                            data = Object.values(data)
                                            data.sort(function (a, b) {
                                                var keyA = new Date(a.start)
                                                var keyB = new Date(b.start)
                                                if (keyA > keyB) return -1;
                                                if (keyA < keyB) return 1;
                                                return 0;
                                            });

                                            $.each(data, function (index, value) {
                                                html += '<option value="' + value['id'] + '">' + value['name'] + '</option>';
                                            });


                                            html += '</select><input type="hidden" class="books_names_field" name="nielsen_radio_books_name_' + match['code'] + '[]"></div></div></div>';
                                            var container = $('#nielsen_radio_books').find('.books_container');

                                            container.append(html);

                                            container.find('select[name="nielsen_radio_books_' + match['code'] + '[]"]').select2({
                                                placeholder: "Select at least one and a maximum of " + match['frequency'],
                                                closeOnSelect: false,
                                                minimumResultsForSearch: 10,
                                                maximumSelectionLength: match['frequency']
                                            }).on('change.select2', function (index) {
                                                var select_name = $(this).attr('name');
                                                var container = $(this).closest('.row .market-ratings-container');
                                                var names = [];
                                                $.each($(this).val(), function (index, value) {
                                                    names.push($(container).find('select[name="' + select_name + '"] option[value="' + value + '"]').html());
                                                });
                                                container.find('.books_names_field').val(names.join());
                                            }).on('select2:select', function (event) {
                                                if(event.params.data.text == 'MARCH 2020' && match['type'] === 'PPM'){
                                                    swal({
                                                            title: "Notification",
                                                            text: "Given the anomalous nature of audience behavior during the COVID-19 Public Health Emergency, it is Nielsen's position that future buying and planning decisions for periods that fall outside the COVID-19 crisis should not be made using COVID-19 impacted audience estimates.",
                                                            type: "warning",
                                                            showCancelButton: false,
                                                            confirmButtonClass: "btn-danger",
                                                            confirmButtonText: "OK",
                                                            //cancelButtonText: "",
                                                            closeOnConfirm: true,
                                                            closeOnCancel: true
                                                        },
                                                        function (isConfirm) {
                                                            if(isConfirm){

                                                            }
                                                        });
                                                }

                                            }).on('select2:selecting', function (event) {
                                                var content = $(this).html();
                                                console.log('----');
                                                console.log(content);
                                                console.log(content.indexOf("Small"));
                                                console.log($(this).val().length);

                                                if(typeof event.params.args !== 'undefined')
                                                    var form_curr_books = $(event.currentTarget).val().concat([event.params.args.data.id]);
                                                else
                                                    var form_curr_books = $(event.currentTarget).val();
                                                var selected = [];
                                                $('#form_books option').each(function(){
                                                    if(form_curr_books.indexOf($(this).val()) !== -1){
                                                        selected.push($(this).text());
                                                    }
                                                });
                                                console.log('form_curr_books: ', form_curr_books);
                                                console.log('event: ', event);

                                                if ($(this).val().length == 1 && content.indexOf("Small") !== -1) {
                                                    event.preventDefault();
                                                    event.stopPropagation();
                                                    global_notification('warning', "You cannot select this survey together with your current survey.\n\n You can only select one condensed market two-book average survey alone since these surveys already include an average of two consecutive surveys.");
                                                    return false;
                                                }
                                            });
                                            $(".select2-selection.select2-selection--multiple:not(:has(i.fa.fa-search.search-icon-input))").prepend("<i class='fa fa-search search-icon-input'></i>")
                                            update_radio_demo_ids_by_markets();

                                            hide_loader();
                                        },
                                        error: function (xhr) {
                                            ajax_error();
                                            hide_loader();
                                        }
                                    });
                                }
                            } else {
                                swal({
                                        title: "Warning",
                                        text: "The market you are selecting a demo for does not have ratings provided. This will require manual ratings entry.",
                                        type: "warning",
                                        showCancelButton: false,
                                        confirmButtonClass: "btn-danger",
                                        confirmButtonText: "OK",
                                        cancelButtonText: "Close",
                                        closeOnConfirm: true,
                                        closeOnCancel: true
                                    },
                                    function (isConfirm) {

                                    });
                            }
                        }

                        //comscore
                        if (type === 'dma') {
                            show_loader();
                            $.ajax({
                                type: "GET",
                                url: '/comscore/ratings/books/market/' + value,
                                dataType: 'json',
                                success: function (data) {
                                    console.log(data);
                                    /*if (typeof nielsen_tv_markets[match['dma']] === 'undefined') {
                                nielsen_tv_markets[match['dma']] = data;
                            }

                            var html = '<div class="form-inline row market-ratings-container" data-market="' + match['dma'] + '" data-media="tv"><div class="form-group col-md-3 m-b-10"><div class="col-md-12"><input class="form-control full-width nielsen_tv_market" id="nielsen_tv_market" name="nielsen_tv_market_name[]" value="' + match['name'] + '" readonly><input type="hidden" name="nielsen_tv_market[]" value="' + match['dma'] + '"/></div></div><div class="form-group col-md-3 m-b-10"><div class="col-md-12"><select class="form-control full-width" id="nielsen_tv_playback_type" name="nielsen_tv_playback_type[]"><option value="">Choose One...</option>';

                            $.each(tv_playback_types[match['type']], function (index, value) {
                                html += '<option value="' + index + '">' + value + '</option>';
                            });

                            html += '</select></div></div><div class="form-group col-md-3 m-b-10"><div class="col-md-12"><select class="form-control full-width" id="nielsen_tv_share" name="nielsen_tv_share[]" disabled></select><input type="hidden" name="nielsen_tv_share_name[]" /></div></div><div class="form-group col-md-3 m-b-10"><div class="col-md-12"><select class="form-control full-width" id="nielsen_tv_hut" name="nielsen_tv_hut[]" disabled></select><input type="hidden" name="nielsen_tv_hut_name[]" /></div></div></div>';
                            var container = $('#nielsen_tv_books').find('.books_container');
                            $(html).find('#nielsen_tv_market').val(match['name']);

                            container.append(html);

                            container.find('div.row[data-market="' + match['dma'] + '"] select[name="nielsen_tv_playback_type[]"]').bind('change', function () {
                                marketMultiSelectNielsenPlaybackChange(this);
                            });*/

                                    hide_loader();
                                },
                                error: function (xhr) {
                                    ajax_error();
                                    hide_loader();
                                }
                            });
                        }
                    }
                    stop_e = false;
                    this.qs1.cache();
                },
                afterDeselect: function (values) {

                    stop_e = false;
                    var enc = false;

                    if (typeof saved_markets !== 'undefined')
                        var h_order = saved_markets[saved_markets.length - 1];
                    else
                        var h_order = false;

                    if (h_order === 1) {
                        if (typeof ordered_markets !== 'undefined') {
                            if (ordered_markets.indexOf(values[0]) !== -1)
                                enc = true;
                            else {
                                console.log("thisnot");
                                console.log(ordered_markets);
                                console.log(values[0]);
                            }
                        } else {
                            console.log("ordered_markets undefined");
                        }
                    }
                    if (h_order == 1 && enc === true) {
                        global_notification('warning', 'This campaign has order(s) created. You can not delete this market');
                        stop_e = true;
                        $(id).multiSelect('select', values);

                    } else {
                        var go = false;
                        if (typeof market_with_lines !== 'undefined' && market_with_lines.indexOf(values[0]) !== -1) {
                            swal({
                                    title: "Warning",
                                    text: 'This market has avails. Do you confirm to remove it?',
                                    type: "warning",
                                    showCancelButton: true,
                                    confirmButtonClass: "btn-danger",
                                    confirmButtonText: "Yes",
                                    cancelButtonText: "Cancel",
                                    closeOnConfirm: true,
                                    closeOnCancel: true
                                },
                                function (isConfirm) {
                                    if (isConfirm) {
                                        var match;
                                        var comscore_match;
                                        var value = values[0];
                                        var type = value.substring(0, 3);
                                        if ((type === 'dma') && (nielsen_tv !== false || comscore_markets !== false)) {
                                            marketRatingsMultiSelectVisibility(this.$element, 'tv');

                                            match = (nielsen_tv) ? nielsen_tv.where('slug', value).first() : undefined;
                                            comscore_match = comscore_markets.findIndex(elem => elem.slug == value)

                                            // match = nielsen_tv.where('slug', value).first();
                                            // if(typeof comscore_markets !== 'undefined' && typeof match === 'undefined') {
                                            //     var found = comscore_markets.find(function (element) {
                                            //         return element.slug == value;
                                            //     });
                                            //     if (typeof found !== 'undefined'){
                                            //         var input = $('.market-ratings-container[data-market="' + found['code'] + '"][data-media="tv"]');
                                            //         if (input.length !== 0) {
                                            //             input.remove();
                                            //         }
                                            //     }
                                            // }

                                            if (typeof match !== 'undefined') {
                                                var input = $('.books_container .market-ratings-container[data-market="' + match['dma'] + '"][data-media="tv"]');
                                                if (input.length !== 0) {
                                                    input.remove();
                                                }
                                            }
                                            if (typeof comscore_match !== 'undefined' && comscore_match !== -1) {
                                                var input = $('.comscore_books_container .market-ratings-container[data-market="' + comscore_markets[comscore_match].code + '"][data-media="tv"]');
                                                if (input.length !== 0) {
                                                    input.remove();
                                                }
                                            }
                                        } else if ((type === 'msa') && (nielsen_radio !== false)) {
                                            marketRatingsMultiSelectVisibility(this.$element, 'radio');
                                            match = nielsen_radio.where('slug', value).first();

                                            if (typeof match !== 'undefined') {
                                                var input = $('.market-ratings-container[data-market="' + match['code'] + '"][data-media="radio"]');
                                                if (input.length !== 0) {
                                                    input.remove();
                                                    update_radio_demo_ids_by_markets();
                                                }
                                            }
                                        }
                                    } else {
                                        stop_e = true;
                                        $(id).multiSelect('select', values);
                                    }
                                });
                        } else {
                            var match;
                            var comscore_match;
                            var value = values[0];
                            var type = value.substring(0, 3);
                            if ((type === 'dma') && (nielsen_tv !== false || comscore_markets !== false)) {
                                marketRatingsMultiSelectVisibility(this.$element, 'tv');

                                match = (nielsen_tv) ? nielsen_tv.where('slug', value).first() : undefined;
                                comscore_match = (typeof comscore_markets !== 'undefined' && comscore_markets !== "" && comscore_markets !== null && comscore_markets.length) ? comscore_markets.findIndex(elem => elem.slug == value) : undefined
                                if (typeof match !== 'undefined') {
                                    var input = $('.books_container .market-ratings-container[data-market="' + match['dma'] + '"][data-media="tv"]');
                                    if (input.length !== 0) {
                                        input.remove();
                                    }
                                }
                                if (typeof comscore_match !== 'undefined' && comscore_match !== -1) {
                                    var input = $('.comscore_books_container .market-ratings-container[data-market="' + comscore_markets[comscore_match].code + '"][data-media="tv"]');
                                    if (input.length !== 0) {
                                        input.remove();
                                    }
                                }
                            } else if ((type === 'msa') && (nielsen_radio !== false)) {
                                marketRatingsMultiSelectVisibility(this.$element, 'radio');

                                match = nielsen_radio.where('slug', value).first();

                                if (typeof match !== 'undefined') {
                                    var input = $('.market-ratings-container[data-market="' + match['code'] + '"][data-media="radio"]');
                                    if (input.length !== 0) {
                                        input.remove();
                                        update_radio_demo_ids_by_markets();
                                    }
                                }
                            }
                        }
                    }

                    this.qs1.cache();
                }
            });
        };

        var selectComscoreYearBooksChange = function (selector) {
            $(selector).on("change", function () {
                var date_range = $(this).parent().parent().parent().find('#avails_view_quarter');
                date_range.html('');
                if ($(this).val() === 'quarter') {
                    var options = '<option value="">Select a Range</option><option value="01-01">January - March</option><option value="04-01">April - June</option><option value="07-01">July - September</option><option value="10-01">October - December</option>';
                    date_range.append(options);
                } else if ($(this).val() === 'month') {
                    var options = '<option value="">Select a Month</option><option value="01-01">January</option><option value="02-01">Febrary</option><option value="03-01">March</option><option value="04-01">April</option><option value="05-01">May</option><option value="06-01">June</option><option value="07-01">July</option><option value="08-01">August</option><option value="09-01">September</option><option value="10-01">October</option><option value="11-01">November</option><option value="12-01">December</option>';
                    date_range.append(options);
                }
            });
        }

        if ($('#comscore_dat #avails_view_year').length) {
            selectComscoreYearBooksChange($('#comscore_dat #comscore_interval'))
        }

        var marketMultiSelectNielsenPlaybackChange = function (select) {
            playback = $(select).val();
            container = $(select).closest('.market-ratings-container');
            market = container.attr('data-market');

            books = collect(nielsen_tv_markets[market]).where('playback_type', playback).all();

            hut_input = container.find('select[name="nielsen_tv_hut[]"]');
            share_input = container.find('select[name="nielsen_tv_share[]"]');

            if (hut_input.hasClass('select2-hidden-accessible')) {
                hut_input.data('select2').destroy();
            }

            if (share_input.hasClass('select2-hidden-accessible')) {
                share_input.data('select2').destroy();
            }


            hut_input.html('<option value=""></option>');
            share_input.html('<option value=""></option>');

            $.each(books, function (index, value) {
                hut_input.append('<option value="' + value['id'] + '">' + value['name'] + ((value['service'] === "NSIX") ? " Impact Data" : "") + '</option>');
                share_input.append('<option value="' + value['id'] + '">' + value['name'] + ((value['service'] === "NSIX") ? " Impact Data" : "") + '</option>');
            });

            hut_input.attr('disabled', null);
            share_input.attr('disabled', null);

            hut_input.select2({
                placeholder: "Select one...",
                minimumResultsForSearch: 10
            }).on('change.select2', function () {
                $(this).closest('.market-ratings-container').find('input[name="nielsen_tv_hut_name[]"]').val($(this).find(':selected').html());
            });
            share_input.select2({
                placeholder: "Select one...",
                minimumResultsForSearch: 10
            }).on('change.select2', function () {
                $(this).closest('.market-ratings-container').find('input[name="nielsen_tv_share_name[]"]').val($(this).find(':selected').html());
            });
            $(".select2-selection.select2-selection--multiple:not(:has(i.fa.fa-search.search-icon-input))").prepend("<i class='fa fa-search search-icon-input'></i>")
        };

        var marketRatingsMultiSelectVisibility = function (select, media) {
            var values = $(select).val();

            if (media === 'tv') {
                vendors = nielsen_tv;
                var container = $('#nielsen_tv_books');
            } else {
                vendors = nielsen_radio;
                var container = $('#nielsen_radio_books');
            }

            var visible = false;

            if (typeof vendors !== 'undefined' && vendors !== false && vendors !== null && vendors !== "") {
                vendors.each(function (item) {
                    if ($.inArray(item['slug'], values) !== -1) {
                        visible = true;
                    }
                });
            }

            if (visible) {
                //container.removeClass('hidden').addClass('shown');
            } else {
                //container.removeClass('shown').addClass('hidden');
            }
        };


        /**
         * Campaigns Forms Logic
         *
         * Views: campaigns/partials/form-tab-dates campaigns/partials/form-tab-settings
         */
//nielsen_tv_playback_type nielsen_tv_share nielsen_tv_hut
//nielsen_radio_geography[] nielsen_radio_books
        /* Create / Edit */
        if ($('#app-campaigns-form-planner').length || $('#app-campaigns-form-planner-monthly').length) {
            form_wizard('#app-campaigns-form-wizard-planner',
                {
                    campaign_name: {
                        required: true
                    },
                    advertiser_name_planner: {
                        required: true
                    },

                    "campaign_media_types[]": {
                        required: true
                    },
                    campaign_date_range: {
                        required: true
                    },
                    campaign_start_of_week: {
                        required: true
                    },
                    campaign_interval: {
                        required: true
                    },
                    camp_gen_commission: {
                        required: true
                    },
                    camp_tv_commission: {
                        required: true
                    },
                    camp_radio_commission: {
                        required: true
                    },
                    camp_ooh_commission: {
                        required: true
                    },
                    camp_print_commission: {
                        required: true
                    },
                    camp_digital_commission: {
                        required: true
                    },
                    camp_mail_commission: {
                        required: true
                    },
                    camp_other_commission: {
                        required: true
                    }
                },
                {
                    campaign_name: "Please define the campaign's name.",
                    advertiser_name_planner: "Please select the advertiser.",
                    campaign_budget: "Please define a budget.",
                    "campaign_media_types[]": "Please choose at least one media type.",
                    "campaign_weeks[]": "You must have at least one flight day or week."
                }
            );

            $('#campaign_media_types').select2({
                placeholder: "Select at least one..",
                closeOnSelect: false
            }).on('select2:unselecting', function (e) {
                var id = e.params.args.data.id; //your id
                if (typeof medias_with_lines !== 'undefined' && medias_with_lines.indexOf(id) !== -1) {
                    swal({
                            title: "Warning",
                            text: 'This Media Type has avails. Do you confirm to remove it?',
                            type: "warning",
                            showCancelButton: true,
                            confirmButtonClass: "btn-danger",
                            confirmButtonText: "Yes",
                            cancelButtonText: "Cancel",
                            closeOnConfirm: true,
                            closeOnCancel: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                var wanted_option = $("#campaign_media_types option[value='" + id + "']");
                                wanted_option.prop('selected', false);
                                $('#campaign_media_types').trigger('change.select2');
                            }
                        });
                    e.preventDefault();
                } else {
                    //console.log(medias_with_lines);
                    //console.log(id);
                }
                // Do something with your id
            }).on('select2:select', function (e) {
                if (e.params.data.id == "tv") {
                    var campaign_markets = $('#campaign_markets').val()
                    for (var i in campaign_markets)
                        $('#campaign_markets').multiSelect('select', campaign_markets[i]);
                }
                if (e.params.data.id == "radio") {
                    var campaign_markets_msa = $('#campaign_markets_msa').val()
                    for (var i in campaign_markets_msa)
                        $('#campaign_markets_msa').multiSelect('select', campaign_markets_msa[i]);
                }
            });
            $(".select2-selection.select2-selection--multiple:not(:has(i.fa.fa-search.search-icon-input))").prepend("<i class='fa fa-search search-icon-input'></i>")
            marketRatingsMultiSelect('#campaign_markets');
            $('#campaign_markets').trigger('change');
            marketRatingsMultiSelect('#campaign_markets_msa');
            $('#campaign_markets_msa').trigger('change');
            marketRatingsMultiSelect('#campaign_markets_custom');
            $('#campaign_markets_custom').trigger('change');

            $('#campaign_brand').select2({
                placeholder: "Select one...",
                minimumResultsForSearch: 20,
                'allowClear': true
            }).on('change', function (e) {
                if ($(this).val() !== null) {

                    var url = $(this).find('option:selected').attr('data-product-url');
                    console.log(url);
                    $.ajax({
                        type: 'GET',
                        url: url,
                        dataType: 'json',
                        encode: true,
                        success: function (data) {
                            var products = [];
                            $.each(data['data'], function (index, value) {
                                products.push({'id': value['slug'], 'text': value['name']});
                            });
                            $('#campaign_product').select2('destroy').html('').select2({
                                'data': products,
                                placeholder: "Select one...",
                                minimumResultsForSearch: 20,
                                'allowClear': true
                            }).removeAttr('disabled');
                        }
                    });
                } else {

                }
            });

            $('#campaign_product').select2({
                placeholder: "Select one...",
                minimumResultsForSearch: 20,
                'allowClear': true
            });
            $('#campaign_brand').on('select2:unselecting', function (e) {
                $('#campaign_product').select2('destroy').html('').select2({
                    placeholder: "Select one...",
                    minimumResultsForSearch: 20,
                    'allowClear': true
                }).prop('disabled', true);

            });
            $(".select2-selection.select2-selection--multiple:not(:has(i.fa.fa-search.search-icon-input))").prepend("<i class='fa fa-search search-icon-input'></i>")

            $('#picker_generate').click();
        }


        $("#campaign_brand").on("change", function () {
            if ($(this).val() === "" || typeof $(this).val() === "undefined" || $(this).val() === null) {
                $('#campaign_product').select2('destroy').html('').select2({
                    'data': [],
                    placeholder: "Select one...",
                    minimumResultsForSearch: 20,
                    'allowClear': true
                }).removeAttr('disabled');
            }
        })

        $(".block_campaign_field").on("change", function () {
            if ($(this).prop("checked") == true) {
                $("input#" + $(this).attr("id").split("block_")[1]).prop("disabled", true)
            } else {
                $("input#" + $(this).attr("id").split("block_")[1]).prop("disabled", false)
            }
        })

        $(".block_estimate_field").on("change", function () {
            if ($(this).prop("checked") == true) {
                $("input#" + $(this).attr("id").split("block_")[1]).prop("disabled", true)
            } else {
                $("input#" + $(this).attr("id").split("block_")[1]).prop("disabled", false)
            }
        })


        $('.wizard-active-comissions').on('click', function () {
            active_comissions();
        });
        $('.wizard-active-fd').on('click', function () {
            active_fd();
        });
        $('.wizard-active-settings').on('click', function () {
            active_settings();
        });

        $('.wizard-next-campaign').on('click', function () {
            if ($('#tab1').hasClass('active')) {
                active_comissions();
                $('.wizard-previous-campaign').css('display', 'inline');
                $('.wizard-next-campaign').css('display', 'inline');
                $('html, body').animate({scrollTop: 0}, 'fast');
            } else {
                active_fd();
                $('.wizard-finish-campaign').css('display', 'inline');
                $('.wizard-next-campaign').css('display', 'none');
                $('.wizard-previous-campaign').css('display', 'inline');
                $('html, body').animate({scrollTop: 0}, 'fast');

            }
        });
        $('.wizard-previous-campaign').on('click', function () {
            if ($('#tab2').hasClass('active')) {
                active_settings();
                $('.wizard-previous-campaign').css('display', 'none');
                $('.wizard-finish-campaign').css('display', 'none');
                $('.wizard-next-campaign').css('display', 'inline');
                $('html, body').animate({scrollTop: 0}, 'fast');
            } else {
                active_comissions();
                $('.wizard-finish-campaign').css('display', 'none');
                $('.wizard-next-campaign').css('display', 'inline');
                $('.wizard-previous-campaign').css('display', 'inline');
                $('html, body').animate({scrollTop: 0}, 'fast');

            }
        });

        var active_comissions = function () {
            if ($('#tab1').hasClass('active')) {
                if ($('#campaign_name').val() == '' || $('#campaign_media_types').val().length == 0 || ($('#campaign_markets').val().length == 0 && $('#campaign_markets_msa').val().length == 0 && $('#campaign_markets_custom').val().length == 0)) {
                    var text = '';
                    if ($('#campaign_name').val() == '')
                        text += 'Define the campaign name.' + ' \n';
                    if ($('#campaign_media_types').val().length == 0)
                        text += 'Choose at least one media type.' + ' \n';
                    if ($('#campaign_markets').val().length == 0 && $('#campaign_markets_msa').val().length == 0 && $('#campaign_markets_custom').val().length == 0)
                        text += 'Select at least one market.' + ' \n';
                    if($('#app-campaigns-form-planner').length) {
                        var $valid = $('#app-campaigns-form-planner').valid();
                        var $validator = form_validator('#app-campaigns-form-planner');
                    }
                    else{
                        var $valid = $('#app-campaigns-form-planner-monthly').valid();
                        var $validator = form_validator('#app-campaigns-form-planner-monthly');
                    }
                    if (!$valid)
                        $validator.focusInvalid();
                    swal({
                            title: "Warning",
                            text: text,
                            type: "warning",
                            showCancelButton: true,
                            confirmButtonClass: "btn-danger",
                            confirmButtonText: "OK",
                            closeOnConfirm: true,
                            closeOnCancel: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                            }
                        });
                } else {
                    $('#tab1').removeClass('active');
                    $('#tab1').removeClass('content-current');
                    $('.li_0').removeClass('active');
                    $('.li_0').removeClass('tab-current');
                    $('.wizard-active-settings').removeAttr('aria-expanded');

                    $('#tab2').addClass('active');
                    $('#tab2').addClass('content-current');
                    $('.li_1').addClass('tab-current');
                    $('.li_1').addClass('active');
                    $('.wizard-active-comissions').attr('aria-expanded', true);

                    $('.wizard-finish-campaign').css('display', 'none');
                    $('.wizard-next-campaign').css('display', 'inline');
                    $('.wizard-previous-campaign').css('display', 'inline');
                }
            }
            if ($('#tab3').hasClass('active')) {
                $('#tab3').removeClass('active');
                $('#tab3').removeClass('content-current');
                $('.li_2').removeClass('active');
                $('.li_2').removeClass('tab-current');
                $('.wizard-active-fd').removeAttr('aria-expanded');

                $('#tab2').addClass('active');
                $('#tab2').addClass('content-current');
                $('.li_1').addClass('tab-current');
                $('.li_1').addClass('active');
                $('.wizard-active-comissions').attr('aria-expanded', true);

                $('.wizard-finish-campaign').css('display', 'none');
                $('.wizard-next-campaign').css('display', 'inline');
                $('.wizard-previous-campaign').css('display', 'inline');
            }
        };
        var active_fd = function () {
            if ($('#tab1').hasClass('active')) {
                if ($('#campaign_name').val() == '' || $('#campaign_media_types').val().length == 0 || ($('#campaign_markets').val().length == 0 && $('#campaign_markets_msa').val().length == 0 && $('#campaign_markets_custom').val().length == 0)) {
                    var text = '';
                    if ($('#campaign_name').val() == '')
                        text += 'Define the campaign name.' + ' \n';
                    if ($('#campaign_media_types').val().length == 0)
                        text += 'Choose at least one media type.' + ' \n';
                    if ($('#campaign_markets').val().length == 0 && $('#campaign_markets_msa').val().length == 0 && $('#campaign_markets_custom').val().length == 0)
                        text += 'Select at least one market.' + ' \n';
                    if($('#app-campaigns-form-planner').length) {
                        var $valid = $('#app-campaigns-form-planner').valid();
                        var $validator = form_validator('#app-campaigns-form-planner');
                    }
                    else{
                        var $valid = $('#app-campaigns-form-planner-monthly').valid();
                        var $validator = form_validator('#app-campaigns-form-planner-monthly');
                    }
                    if (!$valid)
                        $validator.focusInvalid();
                    swal({
                            title: "Warning",
                            text: text,
                            type: "warning",
                            showCancelButton: true,
                            confirmButtonClass: "btn-danger",
                            confirmButtonText: "OK",
                            closeOnConfirm: true,
                            closeOnCancel: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                            }
                        });
                } else {
                    $('#tab1').removeClass('active');
                    $('#tab1').removeClass('content-current');
                    $('.li_0').removeClass('active');
                    $('.li_0').removeClass('tab-current');
                    $('.wizard-active-settings').removeAttr('aria-expanded');

                    $('#tab3').addClass('active');
                    $('#tab3').addClass('content-current');
                    $('.li_2').addClass('tab-current');
                    $('.li_2').addClass('active');
                    $('.wizard-active-fd').attr('aria-expanded', true);

                    $('.wizard-finish-campaign').css('display', 'inline');
                    $('.wizard-next-campaign').css('display', 'none');
                    $('.wizard-previous-campaign').css('display', 'inline');
                }
            }
            if ($('#tab2').hasClass('active')) {
                $('#tab2').removeClass('active');
                $('#tab2').removeClass('content-current');
                $('.li_1').removeClass('active');
                $('.li_1').removeClass('tab-current');
                $('.wizard-active-comissions').removeAttr('aria-expanded');

                $('#tab3').addClass('active');
                $('#tab3').addClass('content-current');
                $('.li_2').addClass('tab-current');
                $('.li_2').addClass('active');
                $('.wizard-active-fd').attr('aria-expanded', true);

                $('.wizard-finish-campaign').css('display', 'inline');
                $('.wizard-next-campaign').css('display', 'none');
                $('.wizard-previous-campaign').css('display', 'inline');
            }
        };
        var active_settings = function () {
            if ($('#tab2').hasClass('active')) {
                $('#tab2').removeClass('active');
                $('#tab2').removeClass('content-current');
                $('.li_1').removeClass('active');
                $('.li_1').removeClass('tab-current');
                $('.wizard-active-comissions').removeAttr('aria-expanded');

                $('#tab1').addClass('active');
                $('#tab1').addClass('content-current');
                $('.li_0').addClass('tab-current');
                $('.li_0').addClass('active');
                $('.wizard-active-settings').attr('aria-expanded', true);

                $('.wizard-finish-campaign').css('display', 'none');
                $('.wizard-next-campaign').css('display', 'inline');
                $('.wizard-previous-campaign').css('display', 'none');

            }
            if ($('#tab3').hasClass('active')) {
                $('#tab3').removeClass('active');
                $('#tab3').removeClass('content-current');
                $('.li_2').removeClass('active');
                $('.li_2').removeClass('tab-current');
                $('.wizard-active-fd').removeAttr('aria-expanded');

                $('#tab1').addClass('active');
                $('#tab1').addClass('content-current');
                $('.li_0').addClass('tab-current');
                $('.li_0').addClass('active');
                $('.wizard-active-settings').attr('aria-expanded', true);

                $('.wizard-finish-campaign').css('display', 'none');
                $('.wizard-next-campaign').css('display', 'inline');
                $('.wizard-previous-campaign').css('display', 'none');
            }
        };

        $('#advertiser_name_planner').on('change', function () {
            var adv_id = $('#advertiser_name_planner option:selected').val();
            $('#adv_id_new_brand').val(adv_id);
            $('#adv_id_new_product').val(adv_id);
            $.ajax({
                type: 'GET',
                url: '/planner/new_campaign/get/advertiser_commission/' + adv_id,
                dataType: 'json',
                encode: true,
                success: function (data) {
                    $('#camp_gen_commission').val(parseFloat(data.general).toLocaleString("en-US", {
                        minimumFractionDigits: 4
                    }) + '%');
                    $('#camp_tv_commission').val(parseFloat(data.tv).toLocaleString("en-US", {
                        minimumFractionDigits: 4
                    }) + '%');
                    $('#camp_radio_commission').val(parseFloat(data.radio).toLocaleString("en-US", {
                        minimumFractionDigits: 4
                    }) + '%');
                    $('#camp_mail_commission').val(parseFloat(data.mail).toLocaleString("en-US", {
                        minimumFractionDigits: 4
                    }) + '%');
                    $('#camp_print_commission').val(parseFloat(data.print).toLocaleString("en-US", {
                        minimumFractionDigits: 4
                    }) + '%');
                    $('#camp_other_commission').val(parseFloat(data.other).toLocaleString("en-US", {
                        minimumFractionDigits: 4
                    }) + '%');
                    $('#camp_digital_commission').val(parseFloat(data.digital).toLocaleString("en-US", {
                        minimumFractionDigits: 4
                    }) + '%');
                    $('#camp_ooh_commission').val(parseFloat(data.ooh).toLocaleString("en-US", {
                        minimumFractionDigits: 4
                    }) + '%');
                    $('#campaign_brand').html('');
                    var html='<option selected></option>';
                    for(var i in data.brands)
                        html+='<option value="'+data.brands[i].slug+'" data-product-url="/advertisers/'+data.advertiser_slug+'/brands/'+data.brands[i].slug+'/products">'+data.brands[i].name+'</option>';
                    $('#campaign_brand').html(html);
                },
                error: function (xhr) {
                    hide_loader();
                    debug(xhr.responseText);
                }
            });

        });

        $('.panel-info-campaign').on('click', function () {
            if(panel_info_campaign_click == 1 && advertisers_or.length == 0){
                swal({
                        title: "Warning",
                        text: "The current agency has no advertisers added, to create a campaign  please create an advertiser first.",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonClass: "btn-danger",
                        confirmButtonText: "OK",
                        cancelButtonText: 'Cancel',
                        closeOnConfirm: true,
                        closeOnCancel: true
                    },
                    function (isConfirm) {
                        if (isConfirm) {
                        }

                    });

            }
            panel_info_campaign_click = 1;

        });

    var generated = false;
    $(document).ready(function () {
        if($('#app-campaigns-update-form').length === 0) {
            generated = !$('#tab_create_new_campaign').hasClass('panel-collapsed');
            if (generated) {
                console.log("TRUEEEEEEEE");
                show_loader();
                $.ajax({
                    type: "GET",
                    url: '/campaigns/lock-numbers',
                    dataType: 'json',
                    success: function (data) {
                        generated = true;
                        console.log('data: ', data);
                        if (agency_obj.automatic_est_no)
                            $('#campaign_estimate').val(String('000000' + data['lock']['est'].estimate_no).slice(-6));
                        if (agency_obj.automatic_camp_no)
                            $('#campaign_number').val(String('000000' + data['lock']['camp'].campaign_no).slice(-6));
                        hide_loader();
                    },
                    error: function (xhr) {
                        console.log('error: ', xhr);
                        hide_loader();
                    }
                });
            }
            $('#tab_create_new_campaign').on('click', function () {
                var collapsed = $('#body_create_new_campaign').css('display');
                if (collapsed !== 'none') {
                    //close tab

                } else {
                    if (!generated && (agency_obj.automatic_camp_no || agency_obj.automatic_est_no)) {
                        //open tab
                        show_loader()
                        //console.log("COMSCORE SECONDARY DEMOS: ", comscore_tv_existing_sec_demo)
                        console.log("COMSCORE SECONDARY DEMOS: ");
                        show_loader();
                        $.ajax({
                            type: "GET",
                            url: '/campaigns/lock-numbers',
                            dataType: 'json',
                            success: function (data) {
                                generated = true;
                                console.log('data: ', data);
                                if (agency_obj.automatic_est_no)
                                    $('#campaign_estimate').val(String('000000' + data['lock']['est'].estimate_no).slice(-6));
                                if (agency_obj.automatic_camp_no)
                                    $('#campaign_number').val(String('000000' + data['lock']['camp'].campaign_no).slice(-6));
                                hide_loader();
                            },
                            error: function (xhr) {
                                console.log('error: ', xhr);
                                hide_loader();
                            }
                        });
                    }
                }
            });
        }
    });

}

